export let opinie_polska =
[{
  source: 'Aleksandrów Kujawski',
  opinion: 'Bardzo interesujący projekt, który uwzględnia potrzeby nie tylko uczniów uzdolnionych, ale również słabszych.'
  },
  {
  source: 'Aleksandrów Łódzki',
  opinion: 'Uczniowie klas czwartych bardzo chętnie pracowali na platformie. Dla niektórych początki były trudne z tytułu obsługi platformy, po kilku realizacjach/tematach nabierali doświadczenia. Sugerowana przez Państwo systematyczność i wynagradzanie za wkład pracy, sprawdziły się. Zadania pomocnicze pełniły rolę naprowadzającą, ale także uczyły cierpliwości ( czasami jej brakowało). Stopniowanie trudności, różnorodność form odpowiedzi, grafika motywowały uczniów do pracy. Osobiście jestem bardzo zadowolona, że brałam udział w tym projekcie.'
  },
  {
  source: 'Augustów',
  opinion: 'Możliwość korzystania z platformy zeszyt.online była dużym wsparciem w pracy z uczniami klasy czwartej. Zdecydowana większość uczniów czekała na zadawanie prac i systematycznie rozwiązywała zadania. Kilku uczniów twierdzi, że zadania pomocnicze były zbyt trudne. Część uczniów szukała wsparcia przy rozwiązywaniu zadań, bo bali się popełniać błędy. Myślę, że warto kontynuować prace nad ćwiczeniami do kolejnych poziomów klas. Moi uczniowie wyrazili chęć pracy na platformie zeszyt.online w klasie piątej.'
  },
  {
  source: 'Baranów Sandomierski',
  opinion: 'System bardzo pomocny. Uczniowie chętnie wykonywali ćwiczenia. Wszystko było jak należy.'
  },
  {
  source: 'Baranów Sandomierski',
  opinion: 'Bardzo fajna sprawa, uczniowie nie mogli się doczekać zadań.'
  },
  {
  source: 'Baranów Sandomierski',
  opinion: 'Przydatny w zajęciach.'
  },
  {
  source: 'Białystok',
  opinion: 'Zadania były ciekawe, uczniowie (oczywiście nie wszyscy) rozwiązywali je w miarę systematycznie i chętnie. Była grupa uczniów, którzy dopominali się o kolejną porcję zadań.'
  },
  {
  source: 'Białystok',
  opinion: 'Świetne narzędzie. Uczniowie chętnie pracowali z zeszytem. Dla nauczyciela nieoceniona pomoc i wsparcie.'
  },
  {
  source: 'Biecz',
  opinion: 'Bardzo pomocny zwłaszcza podczas kształcenia na odległość. Możliwość powtórzenia i utrwalenia wiadomości i umiejętności, super alternatywa dla tradycyjnych zadań domowych.'
  },
  {
  source: 'Biecz',
  opinion: 'Bardzo przydatne narzędzie tak do doskonalenia umiejętności matematycznych jak i ich sprawdzania.'
  },
  {
  source: 'Biecz',
  opinion: 'System zeszyty.online jest bardzo przydatny, w szczególności w czasie zdalnego nauczania. Dobór zadań oraz zadań pomocniczych jest bardzo trafny i pozwala lepiej zrozumieć omawiany materiał, a także wyeliminować utrwalenie się ewentualnego błędu w rozumowaniu. Uczniowie mają możliwość przećwiczenia, utrwalenia czy też uzupełnienia bieżącego materiału, w bardzo atrakcyjnej formie (również graficznej). Nauczyciel może na bieżąco śledzić postępy swoich uczniów. Bardzo ważnym elementem jest wyeliminowanie czynnika stresującego, jakim dla większości uczniów jest ocenianie.'
  },
  {
  source: 'Bielany',
  opinion: 'Zeszyt.online był jednym z kilku narzędzi wykorzystywanych przeze mnie w pracy w ostatnim roku. Uczniowie jednak chętniej korzystali z tego systemu w czasie nauki stacjonarnej. Opinia moja i moich uczniów jest oczywiście pozytywna. Chętnie wykorzystywałabym ten system również do pracy z innymi klasami.'
  },
  {
  source: 'Bieruń',
  opinion: 'Rewelacyjny system do doskonalenia umiejętności matematycznych, ale również umiejętności uczenia się. Rozbudzający zainteresowanie przedmiotem, ciekawość, kreatywność i samokontrolę.'
  },
  {
  source: 'Bieruń',
  opinion: 'Dobre narzędzie, by wspierać naukę uczniów. Jednak w czasie zdalnego nauczania mało uczniów korzystało, ponieważ chyba mieli już przesyt komputera podczas lekcji.'
  },
  {
  source: 'Bieruń',
  opinion: 'Bardzo pomocny zarówno dla nauczyciela jak i ucznia. Uczniowie bardzo zadowoleni (nauczyciel też), że mogli utrwalać swoje umiejętności matematyczne w nowoczesny sposób.'
  },
  {
  source: 'Biłgoraj',
  opinion: 'Bardzo pomocne narzędzie pracy :)'
  },
  {
  source: 'Blachownia',
  opinion: 'Dzieci chętnie odrabiały kolejno zadawane proce domowe.'
  },
  {
  source: 'Blachownia',
  opinion: 'Lekcje są ciekawe, uczniowie chętnie pracują na platformie zeszyty.online. Praca domowa stała się dla uczniów atrakcyjna, wręcz chcą więcej.'
  },
  {
  source: 'Bobolice',
  opinion: 'Program bardzo dobrze opracowany. Przyjemnie się z nim pracowało'
  },
  {
  source: 'Bobolice',
  opinion: 'Uczniowie byli zachwyceni pracą w platformie, chętnie wykonywali polecenia i zdobywali kolejne stopnie awansu.Genialną rzeczą były powtórki, które do skutku sprawdzały zrozumienie i opanowanie danej umiejętności. Dla nauczyciela jest to fantastyczna pomoc, która uatrakcyjnia często nudne zadania z podręcznika. Uczniowie mogą np.manipulować przedmiotami, przesuwać, układać, co bardzo wspiera ich procesie nauki. Dodatkowo widać tu dopasowanie się do ucznia, do jego poziomu, do jego możliwości, podpowiadanie i tłumaczenie czasem nawet szybciej niż to zrobił nauczyciel 😁'
  },
  {
  source: 'Bolesławiec',
  opinion: 'Platforma jest łatwa w obsłudze. Zadania są dobrze dobrane. Idea zadań naprowadzających. sprzyja procesowi edukacyjnemu.'
  },
  {
  source: 'Bolesławiec',
  opinion: 'Zeszyt był bardzo pomocny i przydatny w pracy uczniem, szczególnie w okresie nauki zdalnej. Uczniowie bardzo chętnie brali udział w pracy na platformie, często dopytywali sami o zeszyt.online, o zestawy.'
  },
  {
  source: 'Bolków',
  opinion: 'Narzędzie okazało się pomocne podczas nauki zadanej'
  },
  {
  source: 'Bolków',
  opinion: 'Bardzo przydatne narzędzie, wspomagające pracę nauczyciela oraz uatrakcyjniające uczniom naukę matematyki.'
  },
  {
  source: 'Brańsk',
  opinion: 'Jestem zadowolona z dodatkowego narzędzia jakim jest zeszyt.online.'
  },
  {
  source: 'Brańszczyk',
  opinion: 'Zeszyt online jest przydatny w pracy nauczyciela i uczniów. Spełnił moje oczekiwania'
  },
  {
  source: 'Brześć Kujawski',
  opinion: 'Rewelacja'
  },
  {
  source: 'Celestynów',
  opinion: 'Bardzo dobra pomoc, zamiast zeszytu ćwiczeń, dodatkowa pomoc. Wszystko jest ok'
  },
  {
  source: 'Chęciny',
  opinion: 'Bardzo ciekawy projekt, ale zbyt mało zróżnicowane zadania pod względem trudności. Niektóre działy były proste dla najsłabszych uczniów, a zdolniejsi nie mieli sie jak wykazać. Wszystko było ok, troche więcej wymagających myślenia zadań.'
  },
  {
  source: 'Chęciny',
  opinion: 'Bardzo dobre wsparcie w nauczaniu matematyki. Szczególnie w okresie pracy zdalnej. Uczniowie - Ci bardziej zainteresowani matematyką, bardzo chętnie rozwiązywali zadania na zeszycie.online. Słabsi uczniowie nieco mniej chętnie pracowali z zadaniami, często rozwiązywali je po terminie, po wielokrotnych przypomnieniach ze strony nauczyciela. Szczególnie pomocny był panel umożliwiający przeprowadzanie sprawdzianów i kartkówek.'
  },
  {
  source: 'Chęciny',
  opinion: 'bardzo dobry system'
  },
  {
  source: 'Ciechanowiec',
  opinion: 'ciekawa forma pracy'
  },
  {
  source: 'Czarnia',
  opinion: 'Zeszyt.online jest świetnym narzędziem do samodzielnej pracy uczniów i nieocenioną pomocą dla nauczyciela, zwłaszcza podczas nauki zdalnej. Ci uczniowie, którzy systematycznie pracują na platformie, mają w większym stopniu opanowane wiadomości i umiejętności matematyczne, a to przekłada się na lepsze wyniki w nauce.'
  },
  {
  source: 'Dąbie',
  opinion: 'System działał bardzo dobrze. Uczniowie chętnie odrabiali prace domowe. Wykorzystywałam platformę również do sprawdzenia wiedzy z całego działu, co bardzo ułatwiło mi pracę z czasie nauki zdalnej.'
  },
  {
  source: 'Dobczyce',
  opinion: 'bardzo dobra pomoc w nauce matematyki, wszystko było super'
  },
  {
  source: 'Dobczyce',
  opinion: 'Bardzo dobry, unikatowy pod kątem działania serwis. Uczniowie lubili z nim pracować.'
  },
  {
  source: 'Dobczyce',
  opinion: 'Był super.'
  },
  {
  source: 'Dzierzgowo',
  opinion: 'Bardzo przydatny system. Uczniowie, którzy nie radzili sobie z zadaniami otrzymywali zadania łatwiejsze, naprowadzające. Mogli poprawiać zadania następnego dnia, a otrzymywane medale i ordery motywowały dzieci do ćwiczeń. Z punktu widzenia nauczyciela to doskonała baza zadań na powtórzenia. Wykonywane w trakcie nauczania zdalnego kartkówki czy sprawdziany cieszyły się ogromną popularnością i uczniowie chętnie je rozwiązywali'
  },
  {
  source: 'Dzierżoniów',
  opinion: 'System działał sprawnie. Okazał się bardzo przydatny w nauczaniu zdalnym. Sprawnie funkcjonująca pomoc.'
  },
  {
  source: 'Dzierżoniów',
  opinion: 'Super sprawa. W łatwy sposób mozna było dzieciom udostępnić sprawdzian, zadania domowe czy karty pracy'
  },
  {
  source: 'Dzierżoniów',
  opinion: 'Zeszyt.online spodobał się uczniom. Podobała im się taka forma rozwiązywania zadań domowych. Zeszyt sprawdził się także podczas sprawdzianów i kartkówek. Większość uczniów sprawnie posługiwała się tym systemem.'
  },
  {
  source: 'Dzierżoniów',
  opinion: 'System zeszytu online to wspaniała, innowacyjna platforma. Zadania inspirowały, pomagały w opanowywaniu wiedzy. Rodzice i uczniowie byli zadowoleni.'
  },
  {
  source: 'Ełk',
  opinion: 'Ciekawa forma utrwalenia i powtórzenia materiału. Uczeń uczy się na błędach i może osiągnąć sukces. Mało pracy dla nauczyciela i szybki wgląd w prace i postępy uczniów. Uatrakcyjnienie zajęć stacjonarnych i atrakcyjna praca domowa.'
  },
  {
  source: 'Ełk',
  opinion: 'System jest bardzo przydatny podczas nauczania zdalnego. Moi uczniowie zdecydowanie woleli pisać sprawdziany i kartkówki właśnie na tej platformie. Zadając prace domowe miałam pewność, że każdy uczeń pracuje samodzielnie. Dzieciom bardzo podobają się zadania dodatkowe, które pomagają uzupełnić braki i zrobić zadania w sposób poprawny. Uczniowie po powrocie do szkoły również prosili o dodatkowe zadania na zeszyt.online. Dziękujemy za możliwość korzystania z systemu oraz mamy nadzieję na dalszą współpracę. :)'
  },
  {
  source: 'Ełk',
  opinion: 'Poprawny.'
  },
  {
  source: 'Ełk',
  opinion: 'Bardzo dobry pomysł na pracę z dziećmi o różnych poziomach trudności. Większość dzieci chętnie pracuje na zeszycie.online. Skarżą się tylko na to, że mają dużo zadań do zrobienia. Nie wiedziałam z czego to wynika, ale domyślam się, że niektórym osobom system podrzucał zadania powtórzeniowe i jak ktoś nie zaglądał systematycznie, to nazbierało się tego całkiem sporo. Niektórzy też zauważyłam, że spędzają dużo czasu na zadaniach. Po rozmowie z dziećmi okazywało się jednak, że niektóre logowały się i zajmowały innymi rzeczami. Trudność sprawiły wirtualne ekierki przy zadaniach z geometrii. Dzieci narzekały, że nie dają się przesunąć, czy ustawić jakby chciały. Nie wiem z czego może to wynikać, ale myślę, że duża część dzieci pracowała na telefonie. Ogólne wrażenia dobre. Wszystko było dobrze, a jak coś raz nie działało, to po zgłoszeniu zostało natychmiast poprawione. Także wszystko jest w porządku.'
  },
  {
  source: 'Ełk',
  opinion: 'Zeszyt stanowił wsparcie W nauce zdalnej.'
  },
  {
  source: 'Gniewoszów',
  opinion: 'Mimo, że w tym roku szkolnym 2020/21 z uwagi na panującą sytuację pandemiczną, kontakt z uczniem był wysoce utrudniony, można zaobserwować, że taka forma nauki i rozwiązywania zadań z matematyki bardzo uczniom się podoba. Z pewnością korzystanie z systemu zwiększa w oczach ucznia atrakcyjność przedmiotu. Mogą pochwalić się swoimi osiągnięciami, zdobytymi punktami, wymienić spostrzeżenia - porozmawiać o tym, co sprawiło im trudność, a co było łatwe, zapytać o kolejne zadanie domowe. Łatwiej też jest zachęcić uczniów do pracy - ze względu na to, że system dostosowuje zadania do poziomu umiejętności ucznia, co pozwala mu na szybką poprawę błędów. Myślę, że dzięki pracy na zeszyt.online większość z nich podchodzi do nauki matematyki z większym entuzjazmem, a za rozwiązywane zadania mogą zostać wynagrodzeni oceną.'
  },
  {
  source: 'Gogolin',
  opinion: 'Super pomysł na powtórzenie bieżących wiadomości z lekcji. Nie mam uwag'
  },
  {
  source: 'Gogolin',
  opinion: 'Pozytywna. Uczniowie wręcz prosili, bym wyznaczyła kolejny dzień, gdy będę zadawać zadania dla chętnych i pytali czy w przyszłym roku również będzie zeszyt.online'
  },
  {
  source: 'Goworowo',
  opinion: 'Pozytywna. W klasie 4 uczniowie bardzo chętnie wykonywali prace. Zeszyt bardzo pomagał na nauce matematyki, szczególnie w czasie nauki zdalnej.'
  },
  {
  source: 'Goworowo',
  opinion: 'Zeszyt.online to bardzo cenna pomoc w pracy z dziećmi w nauce stacjonarnej jak również w nauce zdalnej. Uczniowie lubią pracować w oparciu o zeszyt.online i często powtarzają, że rozwiązywanie zadań pozwala im zrozumieć trudne dla nich treści. Niektórzy proszą o dodatkowe prace nie tylko bieżące, ale także powtórzeniowe. Rodzice uczniów klasy czwartej są bardzo zachwyceni tak wspaniałą pomocą.'
  },
  {
  source: 'Góra',
  opinion: 'Ciekawe zadania, utrwalające poznany materiał podczas lekcji.'
  },
  {
  source: 'Góra',
  opinion: 'Super projekt, szczególnie cenny podczas nauczania zdalnego. Uczniowie chętnie wykonywali zadane zadania, często na początku zajęć pytali, czy będzie zadanie domowe w zeszycie online. Rodzice, wielokrotnie wskazywali, że zadania domowe wykonywane w zeszycie online, wskazują od razu błędne odpowiedzi, natomiast zadania pomocnicze pozwalają lepiej zrozumieć treści z lekcji. W bardzo przyjaznej formie zadania, szczególnie z geometrii, świetna animacja, wykorzystująca przyrządy geometryczne, wskazująca poprawne odczytywania pomiarów. Jestem bardzo zadowolona, że miałam możliwość skorzystania z takiej formy wspierającej nauczanie. DZIĘKUJĘ!'
  },
  {
  source: 'Góra',
  opinion: 'Bardzo przydatne narzędzie w pracy z dziećmi.'
  },
  {
  source: 'Góra',
  opinion: 'Jako nauczyciel jestem bardzo zadowolona z zeszytu online. Bardzo pomógł mi w pracy, szczególnie w tak trudnej sytuacji jaką jest pandemia. Dzięki zeszytowi mogłam sprawdzić i zweryfikować poziom wiedzy moich uczniów, z czy sobie radzą, a z czym mają problem i nad czym trzeba jeszcze popracować. Większość uczniów była bardzo zadowolona z zeszytu. Pomagały im zadania pomocnicze jak czegoś nie wiedzieli. Zdarzali się uczniowie, którzy rzadko lub wcale nie korzystali z tej formy pracy, ale spowodowane było to utrudnionym dostępem do internetu.'
  },
  {
  source: 'Grabów nad Prosną',
  opinion: 'Dobry. Czego brakowało? nic'
  },
  {
  source: 'Grabów nad Prosną',
  opinion: 'Bardzo ułatwił mi pracę podczas nauczania zdalnego, chętnie będę z niego korzystać także w przyszłym roku szkolnym.'
  },
  {
  source: 'Grodzisk Wielkopolski',
  opinion: 'Uczniowie chętnie rozwiązywali zadania. Jestem zainteresowana kontynuowaniem pracy w zeszycie online'
  },
  {
  source: 'Hrubieszów',
  opinion: 'Ciekawa forma rozwiązywania zadań przez uczniów'
  },
  {
  source: 'Hrubieszów',
  opinion: 'Praca z projektem była ciekawym doświadczeniem zarówno dla mnie jak i moich uczniów. Niestety nie wszyscy uczniowie aktywnie pracowali z platformą zeszyt.online. Te dzieci, które systematycznie wykonywały zadania miały mniej problemów z nauką matematyki. Duża grupa uczniów chętnie rozwiązywała zadane prace domowe, a nawet domagali się wysyłania sprawdzianów jako formy przygotowania do sprawdzianu właściwego w klasie. Dziękuję organizatorom za możliwość uczestniczenia w projekcie.'
  },
  {
  source: 'Hrubieszów',
  opinion: 'Uczniowi bardzo chętnie rozwiązywali zadania przedstawione w zeszycie online.'
  },
  {
  source: 'Hrubieszów',
  opinion: 'Część uczniów chętnie rozwiązywała zadania i prosiła o kolejne. Niektórzy mówili, że jest to dla nich trudne a niekiedy nie rozumieją poleceń.'
  },
  {
  source: 'Hrubieszów',
  opinion: 'Zadania cieszyły się zainteresowaniem uczniów. Uczniom zdolnym pomagały rozwijać zainteresowania i utrwalać umiejętności, zaś uczniom słabszym pozwalały ćwiczyć i sprawdzać swoją wiedzę oraz poprawiać błędy. Prosimy o kontynuowanie pracy w przyszłym roku szkolnym.'
  },
  {
  source: 'Iłża',
  opinion: 'Zeszyt online był dla mnie i myślę, że dla uczniów w tym trudnym czasie ogromnym wsparciem.'
  },
  {
  source: 'Imielin',
  opinion: 'Nowatorki, odciążający nauczyciela w sprawdzaniu zadań, ciekawie prezentujący treści, bardzo interesujący w realizacji! Uczniowie radzili sobie z zadaniami- czasami skarżyli się na to, że podsuwana pomoc jest dla nich nadal za trudna. Trudno ocenić, na ile dzieci samodzielnie rozwiązywały zadania.'
  },
  {
  source: 'Jarosław',
  opinion: 'Bardzo atrakcyjna forma zadań.'
  },
  {
  source: 'Jarosław',
  opinion: 'Ciekawa i wciągająca forma pracy samodzielnej uczniów. Wspierająca utrwalanie poznanej wiedzy na lekcji, w sposób bardzo atrakcyjny dla ucznia i prosta forma sprawdzania prac domowych uczniów.'
  },
  {
  source: 'Jarosław',
  opinion: 'Uczniowie klasy IV chętnie brali udział w projekcie Matematyka - wstęp do kariery wynalazcy. Rozwiązywali zadania matematyczne na przygotowanej platformie e-learningowej, w ramach której udostępnione były moduły, składające się z zadań na poziomie czwartej klasy szkoły podstawowej. Zadania były zadawane raz na tydzień i na bieżąco sprawdzane przez nauczyciela matematyki. Niektórzy uczniowie często domagali się, aby zadawać więcej zestawów zadań niż tylko raz na tydzień. Jedynie w trakcie ferii zimowych i teraz w czerwcu pod koniec roku uczniowie już niezbyt chętnie rozwiązywali zadania. Myślę, że udział tym projekcie jest dla uczniów wielką szansą na pokonanie własnych trudności oraz podnosi kompetencje matematyczne. Uważam, że jest również doskonałym uzupełnieniem technik kształcenia na odległość i wspomaga szkołę w zdalnym nauczaniu. Taki zeszyt.online można byłoby wprowadzić w klasach 8 w ramach powtórki przed egzaminem z matematyki.'
  },
  {
  source: 'Jarosław',
  opinion: 'Uczniowie kl. IV chętnie rozwiązywali zadania. Nauczyciel miał możliwość wyboru odpowiednich zadań, oraz sprawdzenia podejmowanych prób. Rodzice, którzy mieli dzieci w starszych klasach pytali o zeszyt.online dla uczniów klas V-VIII. Wg mnie, nauczyciela matematyki, taki zeszyt powinien być udostępniony dla każdej klasy'
  },
  {
  source: 'Jarosław',
  opinion: 'Fajna firma.'
  },
  {
  source: 'Jarosław',
  opinion: 'Zeszyt wspierał uczniów w indywidualnym pokonywaniu trudności, co uczniom bardzo się podobało.'
  },
  {
  source: 'Jedlina-Zdrój',
  opinion: 'Zeszytonline to najlepsza pomoc dla nauczyciela. Atrakcyjne zadania, świetne rozwiązania, super pomoc'
  },
  {
  source: 'Jedlnia-Letnisko',
  opinion: 'Udział uczniów w systemie przygotował ich w znaczny sposób do samodzielnego uczenia się matematyki poprzez korzystanie z technologii informatycznej wspomagającej naukę tego przedmiotu szczególnie podczas obecnych czasów. Wzrosła zdrowa rywalizacja wśród uczniów, wiara w ich własne siły, pewność siebie i poczucie własnej wartości. Uczniowie nabyli umiejętność korzystania i rozwijania w sobie swoich mocnych stron powiązanych jest z adekwatną samooceną. Prawidłowo ukształtowana samoocena niewątpliwie wpływa na podejmowane wybory oraz umożliwia lepsze radzenie sobie z wyzwaniami i trudnościami.'
  },
  {
  source: 'Jelenia Góra',
  opinion: 'Bardzo przydatny i przystępny dla ucznia.'
  },
  {
  source: 'Jelenia Góra',
  opinion: 'System jest bardzo przydatny uczniowi, wspiera samodzielne myślenie. Przydało by się wsparcie dla klas piątych'
  },
  {
  source: 'Jelenia Góra',
  opinion: 'Bardzo przydatne narzędzie do nauki matematyki.'
  },
  {
  source: 'Jelenia Góra',
  opinion: 'Fantastyczny system wspomagający pracę nauczyciela, zachęcający uczniów do samodzielnej pracy. Mnogość ćwiczeń pomagających uczniom zrozumienie tematu, zachęcających do samodzielnej pracy i ułatwiających im pracę. Ćwiczeń, w których można ustawiać stopień trudności, pozwala nauczycielowi na dostosowanie zadań do wiedzy i umiejętności ucznia. Możność ustawienia czasu wykonywania zadanych prac pomaga zdyscyplinować uczniów i nauczyć ich systematyczności w pracy. Sprawdziany, które uczniowie mogli pisać w domu, urozmaicały sposoby oceny wiedzy ucznia. Chciałbym pracować w przyszłym roku szkolnym z tym systemem. System w obecnej wersji spełnił moje oczekiwania.'
  },
  {
  source: 'Jelenia Góra',
  opinion: 'System był przydatnym narzędziem w mojej pracy z uczniami. Większość uczniów aktywnie korzystała z zaproponowanych zadań. Zeszyt online był ciekawą alternatywą dla typowych kart zadań dodatkowych. Jego zaletą był fakt, że w trakcie wykonywania ćwiczeń system dobierał przykłady zgodnie z poziomem umiejętności uczniów. Bardzo podobały mi się ćwiczenia interaktywne z geometrii. Szczególnie w dobie nauki zdalnej zdarzało mi się podczas lekcji wykorzystywać zeszyt online aby pokazać uczniom jak przyłożyć kątomierz czy ekierkę aby osiągnąć zamierzony cel (narysowanie rysunku czy wykonanie pomiaru).'
  },
  {
  source: 'Kadzidło',
  opinion: 'Bardzo przydatny program, szczególnie podczas nauki zdalnej'
  },
  {
  source: 'Kadzidło',
  opinion: 'System oceniam bardzo wysoko. Duża baza zadań. Świetnie w tym roku sprawdziła się zakładka do sprawdzianów. Uczniowie też zadowoleni podobały im się zadawane testy, zwłaszcza sprawdziany gdzie nie było ograniczeń czasowych co do każdego zadania. Mniejsze zainteresowanie niż w roku ubiegłym spowodowane było raczej tym, że ze względu na naukę zdalną starałam się im ograniczać czas spędzany przed monitorem do niezbędnego minimum.'
  },
  {
  source: 'Kalisz',
  opinion: 'zadania dobrze dobrane, pomocne, słaby uczeń czasem nie dokańczał pracy'
  },
  {
  source: 'Kalisz',
  opinion: 'Bardzo atrakcyjna forma zadań dla uczniów.'
  },
  {
  source: 'Kalisz',
  opinion: 'Bardzo przydatne narzędzie'
  },
  {
  source: 'Kalisz',
  opinion: 'Bardzo ciekawy program, warty i godny uwagi.'
  },
  {
  source: 'Kalisz',
  opinion: 'Zeszyt.online okazał się świetną alternatywą dla tradycyjnych prac domowych, a zdobywane w nim punkty motywowały uczniów do pracy. Uczniowie chętnie pracowali na platformie, a ja jako nauczyciel mogłam na bieżąco śledzić ich postępy i trudności.'
  },
  {
  source: 'Kalisz',
  opinion: 'Platforma z perspektywy nauczyciela to ciekawe i wygodne narzędzie: pozwala angażować uczniów, daje szybko informację zwrotną.'
  },
  {
  source: 'Kcynia',
  opinion: 'świetny produkt. Jako uzupełninie zajęć doskonały'
  },
  {
  source: 'Kcynia',
  opinion: 'Fajny system i zachęcający uczniów do nauki.'
  },
  {
  source: 'Kcynia',
  opinion: 'Jestem bardzo zadowolona z zeszytu one line. Całkowicie sprostał on moim oczekiwaniom poprzez dostosowanie do odpowiedniego programu nauczania, z którego korzystam. Szczególnie podobały mi się sprawdziany, które można było wykorzystać podczas zdalnego nauczania. Jestem w pełni zadowolona.'
  },
  {
  source: 'Kleczew',
  opinion: 'Platforma jest świetnie przygotowana i była uzupełnieniem nauki zdalnej oraz formą pomocy i indywidualizacji pracy uczniów. Zeszyt online zdobył przychylność uczniów i ich rodziców. Wychowankowie prowadzili dyskusje na temat zadań i sposobu ich rozwiązywania. W drugim półroczu część z nich rzadziej podejmowała się rozwiązania zadań. Powodem było zmęczenie wszelkimi pracami przy komputerze z uwagi na zdalne nauczanie. Większość uczniów z dużym zaangażowaniem realizowała projekt. Zwłaszcza na początku podeszli z wielkim entuzjazmem do rozwiązywania zadań w zeszytach online. Uczniom podobała się możliwość przerwania testu i kontynuowania go w dowolnym momencie. Do rozwiązywania zadań mobilizowały ich przyznawane odznaczenia. Dodatkowo zadania miały atrakcyjną formę i pozwalały na skorzystanie z podpowiedzi, co rozbudzało ciekawość matematyczną. Praca z zeszytem pozwalała uczniom osiągnąć sukces na miarę posiadanych możliwości i realizować zadania w najbardziej dogodnym dla nich czasie. Dzięki nim mogli powtórzyć i przećwiczyć materiał z lekcji. Pewne trudności pojawiły się przy zadaniach dotyczących figur płaskich, a dokładnie korzystania z wirtualnej linijki, kątomierza i cyrkla. Niektórzy uczniowie nie potrafili sobie z tym poradzić co niestety troszkę ich zniechęciło do dalszych wyzwań. Bardzo dziękuję w imieniu nauczycieli, uczniów i ich rodziców za możliwość uczestniczenia w projekcie. Udział w nim był dla uczniów cennym doświadczeniem. Dzięki niemu niektórzy uczniowie przekonali się do nauki matematyki.'
  },
  {
  source: 'Kleszczele',
  opinion: 'Dodatkowa pomoc, zwłaszcza w zdalnym nauczaniu. Forma ciekawa dla ucznia. Pomocna dla nauczyciela.'
  },
  {
  source: 'Kłobuck',
  opinion: 'Korzystaliśmy z zeszytu.online jako dodatkowego zeszytu ćwiczeń w czasie zdalnej nauki. Uczniowie zainteresowani matematyką rozwiązywali zadania nieobowiązkowo. W tym zakresie system spełnił nasze oczekiwania.'
  },
  {
  source: 'Kołbiel',
  opinion: 'Jestem bardzo zadowolona z możliwości pracy w tym systemie, dobór treści i forma zadań jest ciekawa dla uczniów, a dla nauczyciela bardzo pomocna w codziennej pracy. Wszystko mi pasuje.'
  },
  {
  source: 'Koniecpol',
  opinion: 'zeszyt.online pomagał utrwalić wiedzę uczniów, rozwijał logiczne myślenie uczniów. Od nowego roku szkolnego odchodzę na emeryturę i nie wiem kto przejmie tę klasę, ale chciałabym, żeby kontynuował pracę z zeszyt.online.'
  },
  {
  source: 'Końskie',
  opinion: 'System jest bardzo pomocny . Dzieci chętnie z niego korzystały. Mam bardzo dobre zdanie o systemie jako nauczyciel matematyki. Dzieci codziennie pytały o pracę w zeszycie online. Jestem bardzo wdzięczna za pomoc w tym roku szkolnym i liczę na kontynuację. Myślę, że wszystko działało poprawnie, gdyż od razu dzieci wchodziły i wykonywały daną pracę.'
  },
  {
  source: 'Końskie',
  opinion: 'Bardzo dobry system, pomocny zwłaszcza dla dzieci, które mają trudności z matematyką.'
  },
  {
  source: 'Końskie',
  opinion: 'Zeszyt.online to bardzo ciekawa forma rozwijania umiejętności matematycznych, utrwalania na bieżąco wiedzy, rozwiązywania zadań praktycznych.'
  },
  {
  source: 'Kostrzyn',
  opinion: 'Bardzo pomocne narzędzie, uczniowie bardzo chętnie na nim pracowali. Nie brakowało mi niczego'
  },
  {
  source: 'Kostrzyn',
  opinion: 'zeszyt.online był bardzo przydatny w czasie nauki online, świetnie sprawdził się jako praca domowa i powtórki przed sprawdzianami. Większość uczniów chętnie z niego korzystała.'
  },
  {
  source: 'Kostrzyn',
  opinion: 'System na pewno pomocny w nauce matematyki. Ułatwia monitorowanie uczenia się uczniów. Bardzo fajnie, że kompatybilny z aktualnymi podręcznikami różnych wydawnictw. Nie wszyscy uczniowie lubią w ten sposób się uczyć. Zniechęcali się, gdy kolejny raz popełniali błędy i zadania naprowadzające nadal nie dały efektu. Dużo czasu niektórym zabierało rozwiązanie zadania domowego.'
  },
  {
  source: 'Koszalin',
  opinion: 'Bardzo pomocna platforma. Uczniowie również bardzo zadowoleni.'
  },
  {
  source: 'Kościan',
  opinion: 'Pozytywna. Nic nie brakowało'
  },
  {
  source: 'Kościan',
  opinion: 'zeszyt.online bardzo ułatwił pracę podczas nauczania zdalnego, podawane przeze mnie uwagi do zadań były uwzględniane'
  },
  {
  source: 'Kościan',
  opinion: 'Dzięki systemowi zeszyt.online rozwiązywanie zadań zostało zindywidualizowane. Uczniowie chętnie rozwiązywali przydzielone im zadania, wręcz dopominali się o przydzielenie im kolejnych zadań. Zeszyt.online spełnił oczekiwania.'
  },
  {
  source: 'Kościan',
  opinion: 'To świetny sposób na pracę z uczniem. Bardzo się przydał podczas nauki zdalnej. Wszystko jest dobrze przygotowane.'
  },
  {
  source: 'Krajenka',
  opinion: 'System zeszyt.online bardzo mi się podobał, a najbardziej uczniom. Sami prosili o zadania z portalu. Mnie brakowało tego systemu dla pozostałych klas. Jest to wdzięczne narzędzie do nauki matematyki.'
  },
  {
  source: 'Krosno',
  opinion: 'Mnie i moim uczniom system zeszyt.online bardzo przypadł do gustu, doskonała forma powtórek, ćwiczeń, doskonalenia swoich umiejętności, wdrażania uczniów do samodzielnej pracy, wytrwałości w dążeniu do celu.'
  },
  {
  source: 'Krosno',
  opinion: 'Bardzo duże wsparcie dla nauczycieli i uczniów. Nauczyciel zadając na zeszyt.online ma pewność, że każde dziecko otrzyma zadanie dostosowane do jego możliwości intelektualnych. Uczniowie zadowoleni ponieważ mogą pracować samodzielnie i niwelować braki edukacyjne. Rewelacja!!! Myślę, że w następnym roku szkolnym więcej uczniów skorzysta z proponowanej formy pomocy.'
  },
  {
  source: 'Krynica Morska',
  opinion: 'Program bardzo pomocny, indywidualizacja zadań, bogaty w treści, bardzo wciągający, podobał się dzieciom, nie pozostawił dzieci samym sobie podczas niepowodzenia, naprowadzał do poprawnego rozwiązania zadań, nauczał, bawił.'
  },
  {
  source: 'Krzynowłoga Mała',
  opinion: 'Bardzo dobra platforma zarówno dla uczniów jak i nauczyciela. Różnorodność zadań adekwatna do poziomu klasy. Uczniowie chętnie pracowali na tej platformie. Nie mam zastrzeżeń.'
  },
  {
  source: 'Krzyż Wielkopolski',
  opinion: 'bardzo pomocne narzędzie szczególnie podczas pracy zdalnej, większość uczniów chętnie i terminowo wykonywała zadania, dopytywali się, czy już są następne;  chętnie chwalili się jaki stopień otrzymali i jakie zdobyli medale;  zadali pytanie-czy w klasie 5 też będzie zeszy.online'
  },
  {
  source: 'Kutno',
  opinion: 'Pozytywna.'
  },
  {
  source: 'Kutno',
  opinion: 'Zarówno w mojej opinii jako nauczyciela, jak i w opinii moich uczniów system zeszyt.online stanowi duże wsparcie dla dzieciaków przy utrwalaniu poznanych zagadnień. Zadania i przykłady są właściwie dobierane do ich możliwości. Większość uczniów chciałoby kontynuować taką formę nauki przez zabawę.'
  },
  {
  source: 'Kutno',
  opinion: 'Świetny pomysł, bardzo dobrze sprawdził się w mojej klasie. Urozmaicał zajęcia. Pomagał w trudnym czasie pandemii. Brawo👍🏆🎖️😊'
  },
  {
  source: 'Kutno',
  opinion: 'Praca z systemem bardzo twórcza. Dzieci chętnie pracowały. Angażowały się w rozwiązywaniu zadań łatwych i trudnych. Zabrakło podsumowania indywidualnego dla szkół. Jak wyglądał (procentowo) udzial uczniów w tym projekcie (zbadanie systematyczności). Na potrzeby swojej placowki można bylo to zrobić, globalnie nie mamy takiej wiedzy. Dzieci również czekały na spotkania z organizatorami, stacjonarnie lub chociażby online.'
  },
  {
  source: 'Kutno',
  opinion: 'Ciekawa forma pracy dla uczniów, indywidualizacja nauczania poprzez dobór odpowiednich zadań, zadania uczące samodzielnego myślenia oraz szukania rozwiązań.'
  },
  {
  source: 'Legnica',
  opinion: 'Zeszyt pomagał w utrwalaniu materiału, wspierał uczniów w uzupełnianiu braków oraz rozwijał uczniów zdolnych. Nie wprowadzałabym zmian.'
  },
  {
  source: 'Legnica',
  opinion: 'Ciekawa forma sprawdzenia swojej wiedzy. Ważne, że uczniowie są naprowadzani na właściwy wynik, jak źle rozwiążą zadanie. Zadania w innej formie niż w książce, z różną aktywnością i formą rozwiązywania.'
  },
  {
  source: 'Legnica',
  opinion: 'bardzo przydatne narzędzie do dodatkowego ćwiczenia i ugruntowania wiadomości z matematyki'
  },
  {
  source: 'Legnica',
  opinion: 'Zarówno ja, jak i uczniowie jesteśmy bardzo zadowoleni z systemu zeszyt.online. Dzieci bardzo chętnie rozwiązywali zadania na platformie. Szczególnie przydatna okazała się praca w czasie zdalnej nauki. Możliwe było śledzenie postępów uczniów w zdobywaniu wiedzy matematycznej. Ważne było, że nauczyciel miał możliwość uzyskania informacji z jakimi zagadnieniami dzieci sobie nie radzą lub które sprawiają im trudność.'
  },
  {
  source: 'Leoncin',
  opinion: 'Jest to bardzo dobre narzędzie wspierające nauczanie matematyki. Pozwala na zindywidualizowanie nauki zgodnie z możliwościami ucznia. Uczniowie chętnie z niego korzystają, pozwala im uwierzyć we własne możliwości .'
  },
  {
  source: 'Lesznowola',
  opinion: 'System zeszyt.online jest bardzo przydatny do utrwalania wiedzy matematycznej.'
  },
  {
  source: 'Lesznowola',
  opinion: 'Zeszyt.online jest bardzo dobrą formą uzupełniania wiedzy zdobytej na zajęciach. Uczniowie chętnie wykonują zadania zadawane przez nauczyciela.'
  },
  {
  source: 'Lublin',
  opinion: 'Bardzo przydatne narzędzie, które zarówno urozmaica lekcje jak i daje możliwość prac domowych w innej formie. Platforma idealna dla uczniów, którzy muszą poświęcić więcej czasu na naukę matematyki.'
  },
  {
  source: 'Lublin',
  opinion: 'Nowoczesność wymaga logiki, konsekwencji, zdolności kombinacji i kojarzenia we wszystkich sprawach, i poważnych, i błahych. Tego wymaga także życie. Udział w projekcie wzbudził zainteresowanie uczniów, przyczynił się w znacznym stopniu do podniesienia ich kompetencji matematycznych oraz stał się motywatorem do samodzielnej pracy i aktywności w tym zakresie. Praca na platformie Zeszyt online okazał się dla dzieci i dla mnie jako nauczyciela matematyki wspaniałym narzędziem dodatkowej nauki oraz uzupełnieniem lekcji zwłaszcza prowadzonych w systemie zdalnym i hybrydowym. Uczniowie odkryli, że z matematyką można się zaprzyjaźnić i jest bardzo przydatna w życiu codziennym. Moi podopieczni kończąc udział w projekcie powiedzieli: Matematyka jest piękna.'
  },
  {
  source: 'Łask',
  opinion: 'Świetny pomysł, pomoc i dla ucznia i dla nauczyciela. Moi uczniowie sami się o zadania dopominali :) Bardzo chętnie wykorzystałabym zeszyt online w innych klasach. Dziękuję :)) Wszystkie problemy były na bieżąco wyjaśniane za co dziękuję.'
  },
  {
  source: 'Łask',
  opinion: 'Bardzo atrakcyjne narzędzie do pracy dla uczniów i duża pomoc w pracy dla nauczyciela.'
  },
  {
  source: 'Łask',
  opinion: 'Świetna sprawa, bardzo przydatna np. w nauczaniu online. Wspiera nauczyciela, pobudza aktywność uczniów. Większość uczniów chętnie robi zadania, można ich też nagradzać za dodatkowy wkład pracy. W czasie pracy z zeszytem przychodziły mi do głowy pewne drobne modyfikacje, które w moim przypadku by się przydały, ale były na tyle drobne, że umknęły. Generalnie odczucia pozytywne. Na pewno chętnie korzystałbym z tej platformy również w starszych klasach.'
  },
  {
  source: 'Łaskarzew',
  opinion: 'System wspomagał pracę nauczyciela w czasie nauczania zdalnego. Uczniowie rozwiązywali zadania w trakcie lekcji. System dostosowywał zadania do możliwości ucznia, dawał zadania pomocnicze. Uczniowie chętnie rozwiązywali zadania w zeszyt.online. System pomagał zrozumieć nowe pojęcia matematyczne, w szczególności pojęcia z geometrii, które w formie zdalnej było bardzo trudno wyjaśnić. Jestem bardzo wdzięczna, że moi uczniowie klasy 4, 5 i 6 mogli brać udział w tym projekcie. Bardzo mi się podobało to, że miałam podgląd w zadania domowe w trakcie rozwiązywania każdego ucznia. Jeśli uczeń zgłaszał problem mogłam mu udzielić wskazówki. Mogłam sprawdzić, które zadanie robi, ile jeszcze mu zostało do zrobienia.'
  },
  {
  source: 'Magnuszew',
  opinion: 'Bardzo przydatny i skuteczny w dobie nauczania zdalnego. Wielu uczniów korzystało bardzo chętnie. Bardzo pomocne są informację o zaangażowaniu, czasie pracy, systematyczności, problemach dotyczących danych treści. Przydatne do powtórzeń.'
  },
  {
  source: 'Magnuszew',
  opinion: 'Jestem zadowolona z systemu zeszyt. online. widząc, że uczniom też taka forma pracy odpowiada, a ja mam obraz jak uczeń sobie radził z zadaniami. Lubię analizować i śledzić etapy rozwiązywania zadań. Ta forma pracy jest i nowoczesna i ciekawa. jak najbardziej chcę kontynuować w następnym roku współpracę.'
  },
  {
  source: 'Mała Wieś',
  opinion: 'Zeszyt.online bardzo wspierał prowadzenie zajęć matematyki podczas nauczania stacjonarnego oraz podczas nauczania zdalnego. Dla mnie jako nauczyciela zeszyt.online nie musi być ulepszany.'
  },
  {
  source: 'Margonin',
  opinion: 'Bardzo fajne zadania, które dzieci rozwiązywały.'
  },
  {
  source: 'Marki',
  opinion: 'Bardzo dobre i przydatne narzędzie'
  },
  {
  source: 'Mieszkowice',
  opinion: 'Zeszyt.online stanowił w czwartej klasie dosyć skuteczne uzupełnienie pracy szkolnej na lekcjach matematyki. Uczniowie w miarę systematycznie wykonywali zadane prace domowe, jednak często nie dotrzymywali ustalonych terminów. W mojej ponad trzydziestoletniej pracy nauczyciela matematyki udział w tym projekcie był zupełnie nowym doświadczeniem. Dostrzegam pozytywną różnicę w efektach nauczania w klasie IV i większe zainteresowanie uczniów matematyką. Jestem zainteresowany kontynuacją projektu z klasą V. Uczniowie także dopytywali mnie, czy będzie taka możliwość.'
  },
  {
  source: 'Mieszkowice',
  opinion: '1. zadania dostosowana do możliwości dzieci (łatwe i trudniejsze) 2. uczniowie lubiący matematykę bardzo chętnie rozwiązywali zadania'
  },
  {
  source: 'Mikołów',
  opinion: 'Platforma bardzo fajna pod względem umieszczanych zadań. Najlepsze są pytania pomocnicze do udzielonych błędnie odpowiedzi. Uczniowie nie czują się przez to skreśleni a wręcz mają lepszą motywację do udzielenia poprawnej odpowiedzi. Uczniowie bardzo chętnie korzystali z platformy.'
  },
  {
  source: 'Mikołów',
  opinion: 'Bardzo fajny program, który w ciekawy i interaktywny sposób przedstawiał poznane na zajęciach treści matematyczne. Mogą zostać kolejne stopnie edukacji (klasa 5,6,7,8)?'
  },
  {
  source: 'Mikołów',
  opinion: 'Zadania super, czasami za trudne dla uczniów.'
  },
  {
  source: 'Mikołów',
  opinion: 'Zeszyty były pomocne w nauce, zwłaszcza dla uczniów, którzy samodzielnie rozwiązywali zadania. Mam nadzieję, że ucząc w systemie stacjonarnym, będę mogła sprawdzić wiedzę i umiejętności ucznia, a nie osób trzecich.'
  },
  {
  source: 'Mińsk Mazowiecki',
  opinion: 'Moim zdaniem system zeszyt.online to świetny sposób na utrwalenie przez uczniów zdobytej wiedzy. Wspomaga proces nauczania matematyki, sprawia, że nauka dla uczniów jest ciekawsza i przyjemniejsza. Uczniowie chętnie korzystają z zeszyt.online, dopytują o kolejne prace, chcą zdobywać kolejne stopnie, zauważam rywalizację wśród dzieci. Uważam, że szczególnie w dobie nauki zdalnej system zeszyt.online jest świetnym narzędziem wspierającym pracę nauczyciela.'
  },
  {
  source: 'Mława',
  opinion: 'Zeszyt.online bardzo ułatwił pracę i był wsparciem podczas nauki zdalnej. System jasny i czytelny dla uczniów. Dużym plusem jest podsumowanie pracy ucznia i jego indywidualne wyniki na podstawie których nauczyciel mógł planować dalsze etapy pracy zindywidualizowanej.'
  },
  {
  source: 'Myślenice',
  opinion: 'Bardzo pomocne narzędzie w pracy nauczyciela. Zdecydowanym plusem jest to iż uczeń osiągający sukces jest bardziej zmotywowany do dalszej pracy.'
  },
  {
  source: 'Myślenice',
  opinion: 'Bardzo się przydały podczas nauczania zdalnego.'
  },
  {
  source: 'Myślenice',
  opinion: 'Bardzo dobra pomoc jako zadania domowe.'
  },
  {
  source: 'Myślenice',
  opinion: 'Zeszyt.online był bardzo pomocnym narzędziem pracy zwłaszcza podczas zdalnego nauczania. Poza tym uważam, że jest to świetne narzędzie pracy zwłaszcza dla ucznia słabszego, którego nagrody w postaci odznak bardzo motywowały do dalszej pracy.'
  },
  {
  source: 'Namysłów',
  opinion: 'Zeszyt bardzo pomagał mi w prowadzeniu lekcji, przede wszystkim w lekcjach powtórzeniowych. Dzieci bardzo chętnie w nim pracowały. W większości sumiennie wypełniały swoje obowiązki. Zeszyt pomógł im kontrolować swoje odpowiedzi. Często powtarzały na lekcji, żeby uważnie czytać polecenia, bo w przeciwnym razie dostaną więcej zadań do rozwiązania. Oczywiście znaleźli się uczniowie (tak jak w każdej klasie), którzy rozwiązywali zadania powierzchownie lub całkowicie o nich zapominali. Jestem wdzięczna rodzicom dzieci, ponieważ oni również zaangażowali się w ten projekt. Uważam, że zeszyt spełnił swoje zadanie - bardzo dobrze'
  },
  {
  source: 'Nowy Sącz',
  opinion: 'Super sprawa, uczniowie zadowoleni, to nie jest jakaś tam strona z kolejną wersją quizów w stylu sprawdź czy zdasz'
  },
  {
  source: 'Nowy Sącz',
  opinion: 'Moi uczniowie byli bardzo zadowoleni, zwłaszcza na początku. Fajna metoda utrwalania wiadomości. Z matematyki im więcej zadań uczniowie rozwiążą tym lepiej.'
  },
  {
  source: 'Nowy Targ',
  opinion: 'Ta forma ćwiczeń i zadań była bardzo atrakcyjna dla dzieci, z utęsknieniem czekały na kolejne zadania.'
  },
  {
  source: 'Nowy Targ',
  opinion: 'Bardzo dobre wsparcie nauczyciela, ciekawe interaktywne zadania, duży wybór zadań co umożliwia dostosowanie zadań do możliwości każdego ucznia'
  },
  {
  source: 'Opoczno',
  opinion: 'Zeszyty były pomocne zwłaszcza podczas nauczania zdalnego, gdzie nie wszyscy uczniowie mieli możliwość na bieżąco odsylania prac. Uczniowie cieszyli się ze zdobywania kolejnych stopni.'
  },
  {
  source: 'Opoczno',
  opinion: 'Nie jest źle, jest parę rzeczy, które wymagają poprawy. Ale byli uczniowie, którym taka forma odpowiadała, szczególnie podczas pracy zdalnej.'
  },
  {
  source: 'Opoczno',
  opinion: 'Zeszyt. online to projekt prosty w obsłudze, z którego zarówno nauczyciel jak i uczniowie korzystali bardzo chętnie. Ilość dostępnych materiałów jest wystarczająca i zgodna z programem.'
  },
  {
  source: 'Opoczno',
  opinion: 'System zeszyt.online pomagał uczniom zrozumieć przyczynę swoich błędów oraz w indywidualnym tempie nadrabiał zaległości. Wpłynął na postępy w nauce.'
  },
  {
  source: 'Ostrowiec Świętokrzyski',
  opinion: 'Bardzo ciekawy pomysł, przygotowane zadania wspierały moich uczniów'
  },
  {
  source: 'Ostrowiec Świętokrzyski',
  opinion: 'System zeszyt online bardzo mi się spodobał, jest przystępny dla uczniów'
  },
  {
  source: 'Ostrowiec Świętokrzyski',
  opinion: 'Jesteśmy zadowoleni z możliwości wzięcia udziału w projekcie.'
  },
  {
  source: 'Ostrów Mazowiecka',
  opinion: 'System bardzo dobry. Duża pomoc uczniom.'
  },
  {
  source: 'Ostrzeszów',
  opinion: 'Bardzo fajne narzędzie pracy z uczniami. Nie mam żadnych uwag.'
  },
  {
  source: 'Ostrzeszów',
  opinion: 'Udział w tym projekcie oceniam bardzo pozytywnie. Praca na zeszycie online bardzo pomogła mi, właściwie nam, bo zarówno mi jako nauczycielowi, jak i moim uczniom w czasie nauki zdalnej. Zdecydowana większość uczniów pracowała systematycznie, chętnie i z dobrymi rezultatami. Uważam, że przydaje się również w momencie pracy stacjonarnej, bo obecne pokolenie chętnie pracuje cyfrowo itp. Ciekawą sprawą jest możliwość dobierania zadań, raportów, podglądania i sprawdzania jak dziecko pracuje.'
  },
  {
  source: 'Ostrzeszów',
  opinion: 'Bardzo przydatna rzecz przy nauczaniu uczniów klas czwartych, w szczególności w czasach zdalnego nauczania. Również pomocna w nauczaniu stacjonarnym. Uczniowie bardzo zadowoleni z formy sprawdzania swojej wiedzy.'
  },
  {
  source: 'Oświęcim',
  opinion: 'Pomocne narzędzie w utrwalaniu wiedzy uczniów w ciekawej dla nich formie. Nauczyciel miał możliwość bieżącego podglądu na wyniki ucznia i jego aktywność na platformie. Zadania dostosowane do możliwości uczniów. Wskazówki kierujące do poprawnego rozwiązania zadania są bardzo dobrym pomysłem. Uczniowie chętnie korzystali z bazy zadań.'
  },
  {
  source: 'Ożarów Mazowiecki',
  opinion: 'System zeszyt.online jest wspaniały. Dzieci chętnie rozwiązują zadania. Nauczycielowi ułatwia to pracę. Czego brakowało? Aby mogły też korzystać dzieci z 7 i 8 klas.'
  },
  {
  source: 'Ożarów Mazowiecki',
  opinion: 'Bardzo dobra pomoc dydaktyczna.'
  },
  {
  source: 'Ożarów Mazowiecki',
  opinion: 'Wspaniala sprawa,uczniowie bardzo chętnie pracowali,a w tym trudnym czasie praca w ezeszycie dała szansę na utrzymanie i rozwijanie umiejętności,nie wyobrażam sobie tego czasu bez tego narzędzia.'
  },
  {
  source: 'Paczków',
  opinion: 'Bardzo fajna platforma, zadania dopasowane do materiału przerabianego na lekcjach, ładna grafika. Możliwość pominięcia zadania i zrobienia prostszego lub zobaczenia przykładu jest bardzo pomocna, szczególnie, gdy uczeń sam rozwiązuje zadania. Przydatne podczas lekcji zarówno stacjonarnych jak i zdalnych.'
  },
  {
  source: 'Paczków',
  opinion: 'Bardzo fajny projekt.'
  },
  {
  source: 'Paczków',
  opinion: 'Uważam, że platforma jest super. Dzięki sztucznej inteligencji każdy uczeń jest w stanie wykonać zadania, bo system podpowie co i jak. Uczeń korzystający z takiego narzędzia na pewno jest w stanie nauczyć się zagadnienia, które nie do końca umiał lub rozumiał. Chciałbym kontynuować współpracę. Dzieci również były zadowolone i pytały czy jak będzie zadanie domowe to czy na tej platformie.'
  },
  {
  source: 'Pieniężno',
  opinion: ' • uczniowie klas IV brali chętnie udział w samodzielnym rozwiązywaniu otrzymywanych zadań dostosowanych do ich możliwości i aktualnych umiejętności (kompetencje ICT) – zauważyłam większe zaangażowanie uczniów podczas nauczania stacjonarnego  przypominałam i zachęcałam do udziału podczas nauczania zdalnego (część uczniów niesystematycznie pracowała, twierdziła, iż jest zmęczona nauczaniem zdalnym, gdyż dużo czasu spędza przed komputerem kilkoro uczniów poinformowało mnie, że nie wykonywali prac, ponieważ rodzice im zabraniali po lekcjach zdalnych korzystać z komputera, a w wolne dni mieli niby od komputera odpoczywać) • uważam, iż praca na platformie zeszyt.online dla większości uczniów pomocna była w lepszym zrozumieniu przerabianych wiadomości i utrwalaniu umiejętności, gdyż tu uczeń był ukierunkowywany przez system w taki sposób, aby sam zrozumiał przyczynę swojego błędu i miał możliwość poprawienia się, jak również samodzielnie rozwiązać zadanie, które wcześniej było dla niego za trudne  • praca z zeszytem.online była mi pomocna'
  },
  {
  source: 'Pleszew',
  opinion: 'System zeszyt.online bardzo się sprawdził w przypadku klasy, którą uczyłam. Był pomocny zarówno dla mnie jako nauczyciela, jak również dla moich uczniów. Uczniowie chętnie ćwiczyli poznane podczas lekcji zagadnienia korzystając z zeszytu.online. Moim zdaniem oraz zdaniem moich uczniów którzy nie zgłaszali uwag do systemu niczego nie brakowało.'
  },
  {
  source: 'Pleszew',
  opinion: 'Jestem jako nauczyciel bardzo zadowolona z możliwości korzystania z zeszytów. Dla uczniów zwłaszcza w dobie nauki zdalnej, było to super narzędzie do samodzielnej pracy. Miałam prężnie działającą grupę uczniów i chętnie rozwiązywali zadania w zeszytach. z wielką przyjemnością będę korzystała z zeszytów, ale moi uczniowie idą do klasy piątej. Czy w piątej też będą mogli korzystać?'
  },
  {
  source: 'Pleszew',
  opinion: 'Zeszyt online to super platforma edukacyjna. Uczniowie chętnie przystępowali do rozwiązywania zadań. Wręcz czekali, abym zadała dodatkowe zadanie. Ja jako nauczyciel miałam wgląd do ich prac, widziałam, kto pracuje i jak długo poświęca czas na wykonanie zadania. Dzieciom spodobało się zdobywanie stopni wojskowych.'
  },
  {
  source: 'Pleszew',
  opinion: 'Zadania były dostosowanie do możliwości uczniów. Bardzo chętnie korzystałam z tej formy pomocy przy realizacji podstawy programowej. Zeszyt online spełniał moje oczekiwania.'
  },
  {
  source: 'Pleszew',
  opinion: 'Zadania były dostosowane do możliwości uczniów. Chętnie korzystałam z tej formy przy realizacji podstawy programowej.'
  },
  {
  source: 'Pleszew',
  opinion: 'Dzieci, które systematycznie rozwiązywały zadania osiągały bardzo dobre wyniki. Uczniowie mający problemy z matematyką zaczęli samodzielnie pracować, na lekcji byli bardziej aktywni. Dzieci były zadowolone z pracy z systemem, porównywały liczbę zdobytych punktów, czekały na kolejne zadania. Zadania są dostosowane do możliwości uczniów.'
  },
  {
  source: 'Płock',
  opinion: 'Bardzo dobrze nam się pracuje. Szkoda, że nie ma bazy zadań dla klas 7 i 8.'
  },
  {
  source: 'Płock',
  opinion: 'Zeszyt.online sprawdzał się dobrze w trybie stacjonarnym. Po przejściu na nauczanie zdalne oraz platformę Teams uczniowie byli przeciążeni nadmiarem aplikacji - co przełożyło się na znaczny spadek zainteresowania pracą. Podobnie w przypadku nauczycieli - nadmiar aplikacji oraz czasu spędzonego przy komputerze zniechęcał do korzystania z systemu.'
  },
  {
  source: 'Police',
  opinion: 'Bardzo przydatny. Poprzez zadania pomocnicze pozwala uczniom utrwalić te umiejętności, z którymi nie potrafili sobie wcześniej poradzić.'
  },
  {
  source: 'Police',
  opinion: 'Jestem zadowolona z zaproponowanych zadań. Z zeszytu korzystali uczniowie raczej dobrze radzący sobie z nauką. Wszyscy uczniowie pracujący systematycznie z zeszytem otrzymali oceny bardzo dobre i dobre. Dziękuję za udział w programie.'
  },
  {
  source: 'Police',
  opinion: 'System jest ciekawy, zachęcający dzieci do pracy. Możliwości wybierania zadań, monitorowania postępów ucznia, propagowanie samodzielnej jego pracy sprzyja procesowi dydaktycznemu. Stopień trudności zadań wydaje się odpowiedni.'
  },
  {
  source: 'Police',
  opinion: 'Bardzo nam się podobało, ponieważ dzieciom dawało to możliwość poszerzenia ścieżki przy utrwalaniu danego materiału, a nauczycielom to, że uczeń dostawał od razu informację zwrotną co ma źle, zadania były automatycznie sprawdzane.'
  },
  {
  source: 'Pomiechówek',
  opinion: 'Pozytywnie opiniuje pracę na platformie. Uczniowie pracowali z wielkim zaangażowaniem podczas zdalnych lekcji, łączyłam lekcje na teams i prace na zeszycie online.'
  },
  {
  source: 'Pomiechówek',
  opinion: 'Przygotowany przez Państwa zeszyt.online był dla mnie wsparciem w mojej pracy dydaktycznej. Efektywnie wspomagał mnie w pracy zdalnej z uczniami. Także uczniowie chętnie korzystali z tego rozwiązania.'
  },
  {
  source: 'Poręba',
  opinion: 'System zeszyt.online to bardzo przyjazne dla ucznia rozwiązanie, jeśli chodzi o zdalną naukę oraz pracę w domu. Uczniowie chętnie uczą się korzystając z komputera.'
  },
  {
  source: 'Prabuty',
  opinion: 'Bardzo mi się podoba jednak nie jest dla wszystkich uczniow'
  },
  {
  source: 'Prabuty',
  opinion: 'Dzieci były bardzo zadowolone, wielokrotnie powtarzali, ze zeszyt. online bardzo pomagał im w przygotowaniach do klasówek. Bardzo podobały się zadania i to, że można było korzystać z podpowiedzi aby w konsekwencji dobrze rozwiązać zadania. Jako nauczyciel jestem bardzo zadowolona z udziału w projekcie'
  },
  {
  source: 'Pszów',
  opinion: 'Dzięki Zeszyt.online uczniowie mogli powtórzyć i utrwalić wiadomości zdobyte na lekcjach. Jako nauczyciel mogłam sprawdzić który uczeń jest aktywny i jakie zadania sprawiają uczniom trudności'
  },
  {
  source: 'Pułtusk',
  opinion: 'Platforma bardzo interesująca, motywująca uczniów do samodzielnej pracy, uczniowie bardzo chętnie pracowali'
  },
  {
  source: 'Pyzdry',
  opinion: 'Myślę, że bardzo wspierał uczniów i nauczyciela. Uczniowie chętnie wykonywali zadania, pracowali samodzielnie, chociaż niektóre zadania były dla nich trudne. Wszystko było bardzo dobrze zrobione, nie mam pomysłu na ulepszanie.'
  },
  {
  source: 'Różan',
  opinion: 'Ciekawe, przydatne, choć czasami trudne'
  },
  {
  source: 'Rydułtowy',
  opinion: 'Uczniowie chętnie wykonują zadania, traktują to bardzo wesoło - chcą znać ranking w klasie.'
  },
  {
  source: 'Rydułtowy',
  opinion: 'Realizacja i pomysł są bardzo dobre. Część uczniów chętnie i systematycznie korzysta z zasobów. Była grupa, która miała problemy z logowaniem (jednak wynikało to raczej z problemów sprzętowych czy braku motywacji nad kolejnymi godzinami przy komputerze).'
  },
  {
  source: 'Rydzyna',
  opinion: 'Uważam, ze strona bardzo ciekawa. Cieszyła się dużym powodzeniem, ale dla uczniów zdolnych i chętnych poszerzać swoją wiedzę. Mimo, zmotywowania uczniów nie każdy chciał wziąć udział, choć moim zdaniem na prawdę warto. Zwłaszcza w dobie pandemii można było rozwiązywać zadania z rysowaniem za użyciem strony internetowej.'
  },
  {
  source: 'Rzeszów',
  opinion: 'Bardzo dobre narzędzie, zachwalane przez nauczycieli, uczniów i rodziców.'
  },
  {
  source: 'Rzeszów',
  opinion: 'Bardzo dobre dodatkowe narzędzie do pracy'
  },
  {
  source: 'Rzeszów',
  opinion: 'W opinii mojej i uczniów system jak najbardziej sprawdza się. Na chwilę obecną nic nie zmieniałabym.'
  },
  {
  source: 'Rzeszów',
  opinion: 'Uczniowie: zadania fajnie dobrane, bo trochę inne niż w książce. Nauczyciel: bardzo doceniam zadania z geometrii i możliwości ich rozwiązywania online. Ogólnie cały pomysł i platforma super!'
  },
  {
  source: 'Rzeszów',
  opinion: 'Bardzo dobry i profesjonalny system, w nauczaniu online był nieoceniony. Moi uczniowie bardzo chętnie rozwiązywali przypisane zadania. Uzyskałam też bardzo pozytywną opinię rodziców mojej klasy. Chcę zaznaczyć, że wszyscy uczniowie mojej klasy rozwiązywali systematycznie zadania i robili je z chęcią.'
  },
  {
  source: 'Rzewnie',
  opinion: 'Zeszyt.online jest dobrym narzędziem wspomagającym prowadzenie zajęć matematyki. Wspomaga indywidualny rozwój ucznia oraz pozwala mu sprawdzić swoją wiedzę oraz umiejętności zdobyte podczas zajęć. Ten system pozwolił także mi, jako nauczycielowi, na obserwację postępów moich uczniów oraz stwierdzenie jak ich samodzielna praca wpływa na wyniki w nauce.'
  },
  {
  source: 'Rzewnie',
  opinion: 'Dobry pomysł warty kontynuacji. Wszystko było O.K'
  },
  {
  source: 'Sędziszów',
  opinion: 'Dziękuję za możliwość korzystania z zeszytu online, uczniowie systematycznie rozwiązywali zadania. Jest to duża pomoc dla nauczyciela.'
  },
  {
  source: 'Sędziszów',
  opinion: 'Uczniowie bardzo chętnie wykonywali zadania na platformie zeszyt.online. System okazał się również bardzo pomocny przy sprawdzaniu wiedzy podczas nauk zdalnej.'
  },
  {
  source: 'Siedlce',
  opinion: 'Jest to bardzo potrzebna i przydatna pomoc w nauczaniu matematyki w szczególności w czasie nauki zdalnej.'
  },
  {
  source: 'Skała',
  opinion: 'Platforma świetnie się sprawdzała. Idealne narzędzie do utrwalenia wiadomości w czasie nauki zdalnej, ale też trafne urozmaicenie w nauczaniu stacjonarnym. Uczniowie często i chętnie korzystali z platformy.'
  },
  {
  source: 'Skała',
  opinion: 'Doskonała pomoc dla uczniów i dla nauczyciela. Szczególnie sprawdził się podczas zdalnej nauki. Dzieci uwielbiały rozwiazywać zadania w zeszycie online. Prosiły o więcej.'
  },
  {
  source: 'Skała',
  opinion: 'lepsza analiza danych dotycząca konkretnego ucznia'
  },
  {
  source: 'Skierniewice',
  opinion: 'Bardzo ciekawe narzędzie. Uczniowie bardzo je polubili.'
  },
  {
  source: 'Skierniewice',
  opinion: 'Zarówno uczniowie jak i ja, jesteśmy bardzo zadowoleni z udziału w projekcie. Większość uczniów chętnie wykonywała zadania z prac domowych i powtórek. Staraliśmy się, by praca na zeszycie.online była zadawana dwa razy w tygodniu. Jeśli, ze względu na program nauczania, się to nie udawało, uczniowie sami dopominali się o zadania z zeszytu. Możliwość przeprowadzania sprawdzianów za pomocą zeszytu bardzo pomogła mi w prowadzeniu nauki zdalnej. Myślę, że ci uczniowie chętnie kontynuowaliby naukę z zeszytem.online w klasie 5.'
  },
  {
  source: 'Skierniewice',
  opinion: 'Zeszyt bardzo mi się podobał uczniom, też. Przydatny zwłaszcza podczas nauki zdalnej, umożliwiał pracę samodzielną i powtórki, co jest bardzo ważne. Ciężko czasami było poradzić sobie z geometrią- np mierzenie kątów, nie zawsze udawało się myszką dobrze operować w zadaniu.'
  },
  {
  source: 'Skierniewice',
  opinion: 'Zainteresowani uczniowie korzystali z ćwiczeń. Bardzo chętnie je rozwiązywali. Doskonalili umiejętności poznawane na lekcjach. Rozwijali samodoskonalenie i uczyli się systematyczności. Ćwiczenia w zeszycie były dostosowane do materiału realizowanego na lekcjach i przedstawione w ciekawy sposób dla ucznia. Spełniał oczekiwania uczniów.'
  },
  {
  source: 'Skórzec',
  opinion: 'Większość uczniów chętnie korzysta z zeszytów online Najbardziej cenią sobie to, że dzięki pytaniom pomocniczym mogą zrozumieć zadania i samodzielnie je rozwiązać, pomimo początkowych problemów. Zeszyty w dużym stopniu wspierają proces edukacyjny. Wykorzystuję je zarówno w czasie lekcji jak i jako prace domowe/ obowiązkowe i dla chętnych/. Platforma była bardzo przydatna podczas nauki zadanej.'
  },
  {
  source: 'Słubice',
  opinion: 'Duża pomoc w przeprowadzaniu sprawdzianów online, powtórek. Bardzo mi się podoba.'
  },
  {
  source: 'Słubice',
  opinion: 'Bardzo przydatny system jako uzupełnienie programu nauczania. Czego brakowało? Materiały dla pozostałych klas - V-VIII, materiały przygotowujące do egzaminu ósmoklasisty.'
  },
  {
  source: 'Słubice',
  opinion: 'Zdecydowanie nowe, ciekawe wsparcie pracy nauczyciela. Nowy sposób szukania rozwiązań wymagał od uczniów zaangażowania i wytrwałości. Zdarzało się, że uczniowie nie docierali do mety, rezygnowali przed czasem pozostawiając zadanie nie rozwiązane. Ponieważ pracowali w domu trudno ustalić co było przyczyną. Nie mam również pewności, czy wszyscy uczniowie pracowali samodzielnie Dlatego chętnie popracuję z systemem zeszyt.online w przyszłym roku na zajęciach stacjonarnych.'
  },
  {
  source: 'Słupca',
  opinion: 'Udział w projekcie pozwolił utrwalić zdobytą na lekcjach wiedzę, kształtował u uczniów samodzielność, zachęcał uczniów do dodatkowej pracy w domu. Przyczynił się w wielu przypadkach do wzrostu poczucia własnej wartości u uczniów, jak również wspierał uczniów o specyficznych trudnościach w uczeniu się. Budował u uczniów pozytywne nastawienie do przedmiotu.'
  },
  {
  source: 'Słupca',
  opinion: 'System zeszyt.online został bardzo doprze przyjęty przez uczniów. Chętnie wykonywali zadania. Obsługa była wręcz intuicyjna, bez większych problemów. Dla mnie, jako nauczyciela, bardzo przydatne były statystyki. Mogłam obserwować jakie wymagania sprawiają uczniom trudność. Podczas nauki zdalnej przydatne była funkcja sprawdzianu.'
  },
  {
  source: 'Słupno',
  opinion: 'Bardzo przydatna platforma, szczególnie w czasach pandemii'
  },
  {
  source: 'Słupsk',
  opinion: 'Bardzo ciekawe narzędzie, świetnie przydało się w czasie zadlnej nauki'
  },
  {
  source: 'Słupsk',
  opinion: 'Opinia nauczyciela System pomocy dla uczniów jest bardzo ciekawy. Uczniowie wiedzieli że w piątek praca domowa jest zawsze na zeszyt.online. Dopytywali się czy jak wrócimy do szkoły nadal będzie taka praca domowa. W okresie zdalnego nauczania kilkakrotnie wykorzystałam platformę do sprawdzianów. Mogłam w ten sposób sprawdzić czy uczniowie samodzielnie odrabiali prace domowe, ponieważ były zadania o tej samej treści ale z innymi danymi.'
  },
  {
  source: 'Słupsk',
  opinion: 'Bardzo mi się podobało.'
  },
  {
  source: 'Słupsk',
  opinion: 'system zeszyt.online sprawdził się w codziennej pracy z uczniami, często korzystałam zarówno z opcji prac domowych jak i sprawdzianów.'
  },
  {
  source: 'Słupsk',
  opinion: 'Bardzo fajna forma pomocy dla uczniów w nauczaniu matematyki, mogą bez problemu korzystać z niej i uczniowie słabsi jak i zdolniejsi. Dużym motywatorem dla uczniów była forma zabawy, uczniowie w klasie rywalizowali o stopnie wojskowe. Co prawda nie wszyscy brali udział w projekcie, ale byli i tacy, którzy prosili o dodatkowe i częste zajęcia. Mam nadzieję, że zeszyt będzie dostępny dla klasy 5 i 4 od następnego roku. Dziękuję.'
  },
  {
  source: 'Sobienie-Jeziory',
  opinion: 'System zeszyt.online działał bez zarzutu. Uczniowie nie mieli problemów technicznych związanych z logowaniem a nauczyciel z wyborem prac domowych, zmianą dat wykonania oraz indywidualizacją pracy uczniów. Ze względu na nauczanie zdalne zeszyt.online był wykorzystywany jako praca domowa wykonywana samodzielnie przez uczniów. Wydłużający się czas trwania nauczania zdalnego i długi czas spędzany przed komputerem spowodował niechęć uczniów do rozwiązywania prac domowych. Wśród uczniów, którzy mimo wszystko wykonywali ćwiczenia można zaobserwować lepsze opanowanie umiejętności matematycznych.'
  },
  {
  source: 'Sochaczew',
  opinion: 'System zeszyt. online oceniam bardzo pozytywnie, problemem była motywacja uczniów do korzystania z tego narzędzia.'
  },
  {
  source: 'Sokołów PodlaskiSokołów Podlaski',
  opinion: 'Bardzo fajny sposób uczenia. Tylko niektóre przykłady są za trudne tzn. W 4 klasie uczymy dzielić pisemnie przez liczby jednocyfrowe a w zeszycie online zdarzały się przykłady przez liczby dwucyfrowe...'
  },
  {
  source: 'Sompolno',
  opinion: 'System bardzo przydatny. Super'
  },
  {
  source: 'Stalowa Wola',
  opinion: 'Rewelacja. Bardzo pomogły w zdalnym nauczaniu, uczniowie chętnie pracowali. Wszystko jest dobrze'
  },
  {
  source: 'Stalowa Wola',
  opinion: 'Jesteśmy bardzo zadowoleni z programu. Ułatwił pracę na zdalnym nauczaniu, pozwalał utrwalać wiadomości i pomógł w przedstawianiu geometrii. uczniowie bardzo chętnie rozwiązywali zadania w programie zeszyt.online'
  },
  {
  source: 'Stalowa Wola',
  opinion: 'Platforma zeszyt.online jest narzędziem, które pomaga w nauczaniu matematyki. To ciekawe multimedialne zadania matematyczne, które właśnie zachęcają ucznia do pracy. Narzędzie to było głównie wykorzystywane do pracy w domu, zastępowano nim klasyczne prace domowe. Jest to bardzo ciekawy i atrakcyjny sposób rozwiązywania zadań w domu. Efektem pracy na tej platformie jest motywowanie uczniów do nauki. Praca z tym narzędziem zmienia nastawienie do matematyki i do uczenia się. Platforma zeszyt.online to bardzo ciekawe narzędzie, które doskonale wspiera naukę matematyki. Zestawy zadań i zakres są dobrane do potrzeb i możliwości ucznia. Zadania w zeszycie.online pobudzają ciekawość ucznia oraz jego poznawczość. Platforma dała uczniom wiele dodatkowych możliwości, z których mogli skorzystać, aby poprawić efektywność nauki matematyki. Uczniowie bardzo chętnie rozwiązywali zadania w zeszycie.online, wszyscy z ogromną przyjemnością używali tego narzędzia.'
  },
  {
  source: 'Stalowa Wola',
  opinion: 'System zeszyt.online jest bardzo ciekawy dla dzieci. Chętnie rozwiązywali zadania - zwłaszcza w czasie nauki zdalnej. W większości uczniowie nie mieli żadnej pomocy w domu podczas rozwiązywania zadań, więc uzyskane wyniki są bardzo dobre.'
  },
  {
  source: 'Stalowa Wola',
  opinion: 'Bardzo przydatne narzędzie, zwłaszcza podczas nauczania zdalnego. Jest do najlepsza platforma tego typu jaką do tej pory udało mi się poznać.'
  },
  {
  source: 'Stargard',
  opinion: 'Bardzo dobre narzędzie do nauki matematyki. Uczniowie zadowoleni. Wielu z nich chętnie rozwiązywało zadania. Niektórzy poprosili nawet o zadania na wakacje.'
  },
  {
  source: 'Stargard',
  opinion: 'System jest bardzo dobrym wsparciem ucznia, który ma trudności w samodzielnym rozwiązywaniu zadań. Uczniowie ( choć nie wszyscy) z chęcią pracowali z zestawami zadań. Uczniowie zdolni wręcz upominali się o następne zestawy. Jest rzeczą oczywistą, że każda praca dodatkowa podnosi kompetencje kluczowe uczniów. Zestaw zadań pomocniczych był bardzo przydatny uczniom i w efekcie każdy uczeń pracujący z zestawem miał możliwość osiągnięcia sukcesu. To było zachętą by usiąść do następnego zestawu zadań. Dobrym pomysłem jest również nagradzanie kolejnymi stopniami. System zeszyt.online sprawdził się szczególnie w zdalnym nauczaniu.'
  },
  {
  source: 'Stargard',
  opinion: 'Bardzo przydatny podczas utrwalania przerobionego materiału. Dla uczniów z problemami dydaktycznymi pozwala zdiagnozować problem i pomaga uczniom chętnym, stopniując trudności nadrobić braki. Docenia też uczniów zdolnych nadając im stopnie awansu za wykonaną pracę.'
  },
  {
  source: 'Stargard',
  opinion: 'Bardzo dobry pomysł. Fajne zadania.'
  },
  {
  source: 'Stargard',
  opinion: 'Większość uczniów bardzo chętnie pracowała w systemie. Umieszczone zadania pozwalały im rozwijać swoje umiejętności.'
  },
  {
  source: 'Strzelin',
  opinion: 'Pozytywna. Forma ciekawa, uczniowie zainteresowani, zatem wszystko ok.'
  },
  {
  source: 'Suchań',
  opinion: 'System zeszyt.online bardzo pomagał w realizacji podstawy programowej. Dostosowany do indywidualnych potrzeb uczniów.'
  },
  {
  source: 'Suwałki',
  opinion: 'Fajny'
  },
  {
  source: 'Suwałki',
  opinion: 'System sprawdzał się bardzo dobrze w roli dodatkowych prac dla uczniów i jako sprawdziany w nauczaniu online,'
  },
  {
  source: 'Suwałki',
  opinion: 'Zeszyt online był bardzo pomocnym narzędziem podczas prowadzenia lekcji online.'
  },
  {
  source: 'Suwałki',
  opinion: 'Zeszyt sprawdza się przy zadawaniu pracy domowej. Część uczniów chętnie rozwiązywała zadane testy. Uważam, że ten projekt jest dobrym pomysłem na urozmaicenie pracy uczniów.'
  },
  {
  source: 'Syców',
  opinion: 'System zeszyt.online bardzo sprawdził się w zdalnym nauczaniu kiedy nauczyciel miał bardzo mało możliwości korygowania błędów uczniów. Bez wątpienia jest to rewelacyjne narzędzie do samodzielnej pracy uczniów. Z przyjemnością będę kontynuowała pracę z tym narzędziem w następnym roku. Uczniowie raczej byli zadowoleni pracując na zeszycie.online. Myślę, że ich opinia byłaby bardziej miarodajna w normalnej pracy a nie zdalnej.'
  },
  {
  source: 'Syców',
  opinion: 'System bardzo przypadł do gustu dzieciom, nawet w trakcie zdalnego nauczania. Dzieci często pytały, czy zadanie domowe zostanie zadane na zeszycie.online. Jestem zadowolona z podanego przez Państwa narzędzia i mam nadzieję, że będzie możliwa kontynuacja udziału w projekcie w przyszłym roku szkolnym również dla kl. V.'
  },
  {
  source: 'Szamocin',
  opinion: 'Bardzo fajny i pomocny system. Naprawdę jestem bardzo zadowolona.'
  },
  {
  source: 'Szczecinek',
  opinion: 'Bardzo fajnie i przydatne narzędzie utrwalajace'
  },
  {
  source: 'Szczuczyn',
  opinion: 'Ciekawa forma zadań. Duża pomoc dla N-la i uczniów. Zadania super.'
  },
  {
  source: 'Szelków',
  opinion: 'Bardzo dobra pomoc do pracy z uczniami. W tym roku szkolnym, ze względu na nauczanie zdalne znacznie mniej wykorzystałam. Powodem było ograniczanie pracy przy komputerze. W następnym roku postaram się, aby uczniowie częściej pracowali w tym systemie zeszyt on line. Nic bym nie zmieniała. Nie mam uwag.'
  },
  {
  source: 'Środa Wielkopolska',
  opinion: 'Program jest bardzo pomocny uczniom w zrozumieniu i utrwaleniu przerabianego materiału. Moi uczniowie chętnie wykonywali zadania.'
  },
  {
  source: 'Środa Wielkopolska',
  opinion: 'Zeszyt.online bardzo podobał się moim uczniom. Dobrzy uczniowie dopytywali o to, kiedy będą uruchomione kolejne tematy. Niektórym dzieciom brakowało motywacji do rozwiązania do końca proponowanych zadań.'
  },
  {
  source: 'Świebodzin',
  opinion: 'Jestem bardzo zadowolona z pracy z zeszytami online, moi uczniowie również. Wykorzystywałam je jako zadania domowe, samodzielna prace na lekcji lub sprawdziany. Chętnie będę pracować w przyszłym roku szkolnym.'
  },
  {
  source: 'Świebodzin',
  opinion: 'Zeszyt online był bardzo pomocny w pracy zdalnej, uczniowie chętnie rozwiązywali zadania, powtarzali i utrwalali bieżące lekcje. Chciałabym , żeby taki zeszyt był dla klasy siódmej.'
  },
  {
  source: 'Terespol',
  opinion: 'Bardzo się nam podobała praca z zeszyt.online. Chcielibyśmy kontynuować współpracę w klasach piątych i jeżeli jest to możliwe w klasach czwartych.'
  },
  {
  source: 'Terespol',
  opinion: 'Jestem zadowolona, podobały mi się sprawdziany, szczególnie sposób sprawdzania'
  },
  {
  source: 'Trzebinia',
  opinion: 'Bardzo dobra platforma. Chętnie korzystałam z jej zadań.'
  },
  {
  source: 'Trzebinia',
  opinion: 'Wspaniale sprawdza się w pracy z uczniami w pracy dodatkowej. Buduje wewnętrzną motywację do pracy. Uczy wytrwałości.'
  },
  {
  source: 'Trzebinia',
  opinion: 'Zeszyt.online. cieszył się dużą popularnością wśród uczniów. Szczególnie potrzebny okazał się w nauce zdalnej.'
  },
  {
  source: 'Trzebinia',
  opinion: 'Podobała mi się taka forma rozwiązywania zadań z ukierunkowaniem na pracę ucznia, dająca mu wskazówki, a nie gotowe rozwiązanie.'
  },
  {
  source: 'Trzebinia',
  opinion: 'Zeszyt pomocny w nauce. Ogólnie bardzo pozytywnie oceniam państwa "zeszyt online". Bardzo dziękuję za pomoc w pracy.'
  },
  {
  source: 'Trzebinia',
  opinion: 'Świetnie przygotowane zadania, atrakcyjne graficznie, poprawne merytorycznie. Uczniowie chętnie rozwiązywali zadania.'
  },
  {
  source: 'Turek',
  opinion: 'Zadania były dostosowane do wydawnictwa na którym pracuje szkoła, co usprawniło zadawanie konkretnych partii materiały do nauczania. Uczniowie chcący poprawić swoją wiedzę, chętnie rozwiązywali zadania z zeszytu online.'
  },
  {
  source: 'Turek',
  opinion: 'Opinia pozytywna. Nic nie brakowało.'
  },
  {
  source: 'Turek',
  opinion: 'Dzień dobry Zeszyt online bardzo zainteresował uczniów, chętnie pracowali i przypominali o przesłaniu zadań. Mam nadzieję, że w klasie 5 będzie kontynuacja. pozdrawiam'
  },
  {
  source: 'Turek',
  opinion: 'Zeszyt online jest pomocny jako dodatkowa forma utrwalenia umiejętności matematycznych zdobytych na lekcjach.'
  },
  {
  source: 'Turek',
  opinion: 'Bardzo ciekawa i pomocna forma pracy z uczniami. W pracę moich uczniów jednak zbyt często ingerowali rodzice.'
  },
  {
  source: 'Twardogóra',
  opinion: 'System zeszyt.online był pomocnym narzędziem w nauce matematyki zwłaszcza podczas nauczania zdalnego. Zadań była adekwatna ilość do poziomu czwartoklasisty. Trudność zadań różna, to też trzeba zaliczyć na plus. Brakowało takiego systemu dla klas starszych V-VIII'
  },
  {
  source: 'Tychy',
  opinion: 'Świetne narzędzie do pracy samodzielnej.'
  },
  {
  source: 'Tychy',
  opinion: 'Ciekawy i pomocny jako uzupełniający system aktywacji uczniów.'
  },
  {
  source: 'Tychy',
  opinion: 'Zeszyt online był dużym wsparciem w nauce dla uczniów. Uczniowie chętnie rozwiązywali zadnia. Widoczne były efekty ich pracy z zeszytem online. Ambitni uczniowie domagali się większej ilości zadań'
  },
  {
  source: 'Tychy',
  opinion: 'Będę chciała kontynuować w przyszłym roku. System ciekawy i pomocny.'
  },
  {
  source: 'Tychy',
  opinion: 'ciekawa dodatkowa forma pracy'
  },
  {
  source: 'Tychy',
  opinion: 'Bardzo dobre narzędzie wspomagające naukę matematyki. Odpowiednia korelacja między treściami omawianymi na lekcjach, a zadaniami w zeszycie.online. Bez dużych nakładów czasowych ze strony nauczyciela, umożliwił uczniom kształtowanie umiejętności wykorzystania wiedzy w praktyce. Wdrażał uczniów do systematyczności. Uczniowie domagali się kolejnych zadań. Dobra opinia rodziców o tym narzędziu.'
  },
  {
  source: 'Tychy',
  opinion: 'Zeszyt był ulepszany na bieżąco. Dziękuje za współpracę. Uczniom się bardzo podobało.'
  },
  {
  source: 'Tychy',
  opinion: 'Jesteśmy zadowoleni z możliwości korzystania z platformy. Było to dla uczniów i nauczyciela urozmaicenie w prowadzeniu lekcji. Uczniowie i nauczyciel są zainteresowani kontynuacją.'
  },
  {
  source: 'Ustrzyki Dolne',
  opinion: 'Bardzo fajny system. Dzieci z przyjemnością pracowały, starały się na bieżąco rozwiązywać zadania, zgłaszały problemy z rozwiązaniem zadań do nauczyciela i mogły od razu otrzymać odpowiedź. Bardzo dobrze sprawdziła się ta forma w czasie pandemii. Mogłam wzbogacić i rozszerzyć dzieciom zeszyt ćwiczeń, widzieć na bieżąco ich poczynania. najbardziej zaangażowali się uczniowie bardzo słabi z matematyki, którzy podczas lekcji potrzebują więcej czasu i wsparcia nauczyciela. Jako pierwsi rozwiązywali zdane zadania.'
  },
  {
  source: 'Ustrzyki Dolne',
  opinion: 'Na początku, praca w systemie zeszyt.online ( wrzesień - październik) przynosiła zamierzone efekty, dzieci były zadowolone z możliwości rozwiązywania zadań, utrwalały wiadomości i umiejętności. Później po wprowadzeniu nauki zdalnej rodzice nie byli zadowoleni z pracy swoich dzieci w systemie zeszyt.online. Przekazali informację, że dziecko po 6-7 godzinach obowiązkowych lekcji zdalnych jest wystarczająco zmęczone.'
  },
  {
  source: 'Wadowice',
  opinion: 'jest bardzo pomocny dla nauczyciela- przygotowane sprawdziany, prace domowe i szybki ich wynik a od strony ucznia pomoc w zrozumieniu treści poprzez pytania naprowadzające.'
  },
  {
  source: 'Wałbrzych',
  opinion: 'W ankiecie na koniec roku uczniowie wyrazili swoją opinię na temat wykonywanych zadań. Okazało się, że chociaż dla większości uczniów matematyka jest trudna, to jednak zadania na zeszyt.online rozwiązywali chętnie i dawało to im satysfakcję. System zeszyt.online jest pomocny w pracy podczas lekcji, dodatkowych zajęć. System działa sprawnie, nie mam uwag.'
  },
  {
  source: 'Wałbrzych',
  opinion: 'System zeszyt.online wspiera nauczyciela w pracy edukacyjnej. Uczniowie utrwalają pojęcia matematyczne poprzez wykonywanie dodatkowych zadań wygenerowanych dla każdego indywidualnie w zależności od popełnianych wcześniej błędów.'
  },
  {
  source: 'Wałbrzych',
  opinion: 'System bardzo pomocny w prowadzeniu lekcje podczas nauczania zdalnego. Również w czasie zajęć stacjonarnych wykorzystywałem go często do zadawania zadań domowych (na sprawdzanie zadań zawsze jest na lekcji mało czasu, a zeszyt.online robi to automatycznie).'
  },
  {
  source: 'Wałbrzych',
  opinion: 'Oceniam bardzo wysoko cały system. Jest to niesamowicie przydatne narzędzie, szczególnie w czasie nauki zdalnej. Zeszyt.online pomógł moim uczniom zrozumieć matematykę. Dziękuję za możliwość korzystania z systemu.'
  },
  {
  source: 'Wałbrzych',
  opinion: 'pozwalał rozwijać samodzielnie kompetencje matematyczne uczniów, jestem zadowolona z takiej formy pracy z uczniami, mobilizowało ich do uzyskania dobrych wyników i podwyższenia oceny z matematyki'
  },
  {
  source: 'Wałbrzych',
  opinion: 'Praca z zeszytem online podobała się uczniom.'
  },
  {
  source: 'Wałbrzych',
  opinion: 'System zeszyt online spełnił moje i dzieci oczekiwania. Uczniowie bardzo chętnie korzystali z takiej formy pracy na lekcji i w domu.'
  },
  {
  source: 'Węgrów',
  opinion: 'Ciekawe zadania, możliwość utrwalenia i poszerzenia wiadomości. Zadania interaktywne są interesujące dla uczniów. Rodzice uczniów są zadowoleni, że ich dzieci mają możliwość rozwiązania dodatkowych zadań.'
  },
  {
  source: 'Wiązowna',
  opinion: 'Zdania bardzo się uczniom podobają, część z nich chętnie i systematycznie je rozwiązuje. Niestety podczas nauki online nie mogę zadać uczniowi prac domowych wymagających kolejnych godzin spędzonych przed ekranem. Tego Państwo nie możecie poprawić - zeszyt.online jest świetną pomocą w nauce, ale podczas nauki stacjonarnej.'
  },
  {
  source: 'Wierzbno',
  opinion: 'Bardzo dziękuję za możliwość wzięcia udziału w projekcie. Podczas trudnego czasu - pandemii- trochę uczniowie mieli już dosyć komputera, ale mogliśmy sprawdzić się co poszło nam nieźle, a z czym będą problemy w przyszłym roku szkolnym. Zadania są tak dobrane, że wyłapują wszystkie ważne elementy z danego tematu. Różnorodność zadań i możliwość zmiany danych pozwalała z uczniami jeden temat zrobić wspólnie na lekcji i później zadać jako praca domowa to samo, co przy zdalnym nauczaniu bardzo pomagało. Widać ile serca w ten projekt wkłada zespół zeszyt.online, zadania dobrane z podręcznikiem ze stopniowaniem trudności, ładna grafika, szybka komunikacja, możliwość odczytania wszystkiego na bieżąco, sprawnie można było przeprowadzić sprawdzian - tak trzymać! Jeszcze raz dziękuję za wszystko w swoim i uczniów imieniu i liczę na dalszą współpracę. Wszystkim życzę dużo zdrowia, miłego odpoczynku, słońca i radości na czas wakacji, nabrania mocy i energii do nowych wyzwań. Pozdrawiam'
  },
  {
  source: 'Wilamowice',
  opinion: 'Bardzo dobre narzędzie pracy i zabawy dla dzieci, służące powtórzeniu i utrwaleniu zdobytych wiadomości.'
  },
  {
  source: 'Wilamowice',
  opinion: 'Bardzo dobra pomoc dla nauczyciela i ucznia. Zadanie ciekawe, ładna szata graficzna. Godne polecenia.'
  },
  {
  source: 'Włocławek',
  opinion: 'Bardzo wspomógł pracę z uczniami. Wszystko było ok.'
  },
  {
  source: 'Włocławek',
  opinion: 'Narzędzie wspierające pracę nauczyciela i ucznia.'
  },
  {
  source: 'Włocławek',
  opinion: 'Bardzo pomocne w pracy z uczniami, szczególnie w trakcie nauczania zdalnego przydatne narzędzie do prac. Jestem bardzo zadowolona z tej formy pracy z uczniami.'
  },
  {
  source: 'Włocławek',
  opinion: 'Wspaniałe narzędzie do pracy, szkoda że miałam możliwość wykorzystania tylko w klasie czwartej. Chętnie korzystałabym również w starszych klasach.'
  },
  {
  source: 'Włocławek',
  opinion: 'Zeszyt. online bardzo dobrze przygotowany jako pomoc dla nauczyciela matematyki. Uczniowie z chęcią podejmowali się rozwiązywania zadań. Podczas zdalnego nauczania zeszyt pomagał mi w sprawdzaniu wiadomości i umiejętności uczniów. Rodzice również wystawili pozytywną opinię. Byłam zadowolona, nie mam żadnych uwag. Chciałabym, aby zeszyt był udostępniony we wszystkich klasach szkoły podstawowej klas 4-8.'
  },
  {
  source: 'Włocławek',
  opinion: 'Bardzo dobry system, uczniowie chętnie rozwiązywali zadania'
  },
  {
  source: 'Włocławek',
  opinion: 'Jako nauczyciel jestem bardzo zadowolona, dzieci również były zadowolone, większość chętnie pracowała, cieszyła się ze zdobycia tytułów.'
  },
  {
  source: 'Włoszczowa',
  opinion: 'Bardzo ciekawe narzędzie, które pozwalało sprawdzić się uczniom.'
  },
  {
  source: 'Wrocław',
  opinion: 'Bardzo przydatna dla nauczyciela i ciekawa dla uczniów formą pracy indywidualnej'
  },
  {
  source: 'Wrocław',
  opinion: 'Bardzo interesujące narzędzie, wspierające ucznia w odrabianiu zadań z matematyki.'
  },
  {
  source: 'Wrocław',
  opinion: 'Bardzo podobał nam się program. Uczniowie chętnie z niego korzystali.'
  },
  {
  source: 'Wrocław',
  opinion: 'Bardzo przyjazna forma wizualna jak i merytoryczna. Uczniowie bardzo zadowoleni z możliwości dodatkowych ćwiczeń. Uczniom taka forma zadań domowych bardzo odpowiada. Projekt oceniają bardzo pozytywnie. Oto kilka wypowiedzi uczniów klasy 4e: Zeszyt online jest super, ​ Podoba mi się, że są różne poziomy i że, gdy ktoś źle odpowie, lub da nie wiem, to dają kolejne łatwiejsze zadania i tłumaczą, Program pomaga mi w powtórzeniach do kartkówki lub sprawdzianu.'
  },
  {
  source: 'Wrocław',
  opinion: 'Program bardzo przydatny. Szkoda, że skierowany tylko do uczniów klas czwartych. Chętnie kontynuowałabym współpracę w kl. V.'
  },
  {
  source: 'Wrocław',
  opinion: 'Program interesujący. Duża część dzieci pracowała z programem. Rodzice zadowoleni z dodatkowego wsparcia w nauce.'
  },
  {
  source: 'Wrocław',
  opinion: 'System zeszyt.online jest znakomitym uzupełnieniem materiału omawianego na lekcji. Niestety ten rok szkolny sprawił, że uczniowie dużo czasu przebywali przed komputerem i wielu uczniów niechętnie podejmowało się dodatkowych działań, zwłaszcza drogą elektroniczną. Uważam, że to jednak jest ich wybór i cieszę się, ze miałam możliwość zaproponowania im dodatkowego wsparcia.'
  },
  {
  source: 'Września',
  opinion: 'bardzo fajny system, pomocny w ćwiczeniach w domu dzieci, intuicyjny.'
  },
  {
  source: 'Września',
  opinion: 'Dla mnie zeszyt online był dużą pomocą. Uczniowie mogli utrwalać i powtarzać przerobiony materiał. Dawałam im dużo czasu na wykonanie poszczególnych zadań domowych. Byli zadowoleni. Tylko kilka razy zdarzyło mi się, że ktoś potrzebował mojego wyjaśnienia. Dla nauczycieli to bardzo duże ułatwienie. Nie wiem w jakim stopniu zeszyt online wpłynął na sukces uczniów, ale w badaniu wyników nauczania na początku roku szkolnego klasa znajdowała się na poziomie średnim, a w badaniu końcoworocznym - poziom wyżej średni ( ogólnopolskie badanie - Lepsza Szkoła). W naszej gminie do projektu przystąpiły 3 szkoły. Każdy z uczestniczących w projekcie nauczycieli wytypował najbardziej systematycznych i rzetelnych uczniów. 11 uczniów w gminie otrzymało dyplomy i nagrody za pracę w projekcie. Myślę, że będą jeszcze bardziej zmotywowani do pracy w przyszłym roku. Chętnie będę kontynuować pracę koordynatora.'
  },
  {
  source: 'Września',
  opinion: 'Super pomoc w nauczaniu matematyki'
  },
  {
  source: 'Września',
  opinion: 'Bardzo fajne narzędzie do pracy, szczególnie zdalnej. Większość uczniów chętnie rozwiązywała zadania.'
  },
  {
  source: 'Września',
  opinion: 'Bardzo dobre narzędzie do kontroli systematyczności pracy uczniów (przede wszystkim podczas pracy zdalnej). Możliwość stopniowania trudności zadań oraz układania sprawdzianów.'
  },
  {
  source: 'Września',
  opinion: 'Zeszyt bardzo podoba się uczniom. Pracują aktywnie i chętnie.'
  },
  {
  source: 'Zabrze',
  opinion: 'W czasie zdalnego nauczania rewelacja.'
  },
  {
  source: 'Zabrze',
  opinion: 'System działał sprawnie, chociaż nie wszyscy uczniowie umieli z niego korzystać'
  },
  {
  source: 'Zabrze',
  opinion: 'Zadania były różnorodne, można było dostosować treść i czas rozwiązywania do możliwości każdego'
  },
  {
  source: 'Zakliczyn',
  opinion: 'Jestem zainteresowana dalszą współpracą z zeszyt.online'
  },
  {
  source: 'Zalewo',
  opinion: 'Bardzo przydatne narzędzie. Czego brakowało? Więcej klas.'
  },
  {
  source: 'Zalewo',
  opinion: 'System pomaga w realizacji podstawy programowej. Uczniowie bardzo chętnie wykonują przesłane im ćwiczenia. Doskonalą umiejętności wprowadzane na lekcji. Sprawnie można również szczególnie w czasie nauki zdalnej przeprowadzić diagnozę z poszczególnych umiejętności. Zainteresowana jestem również możliwością wykorzystania systemu w innych klasach szkoły podstawowej.'
  },
  {
  source: 'Zarzecze',
  opinion: 'System bardzo dobry. Sprawdziany i kartkówki ułatwiły zdalną naukę.'
  },
  {
  source: 'Ząbkowice Śląskie',
  opinion: 'Bardzo przydatne narzędzie wspomagające naukę matematyki. Indywidualizacja nauki zachęca uczniów do korzystania z platformy. Uczeń jest w stanie samodzielnie rozwiązać różnorodne zadania przez co buduje się jego poczucie własnej wartości. Chętniej podejmuje próby uzyskania prawidłowych wyników analizując kolejne przykłady oraz nadrabiając zaległości.'
  },
  {
  source: 'Zdzieszowice',
  opinion: 'super'
  },
  {
  source: 'Zdzieszowice',
  opinion: 'Zadania dodatkowe bardzo przyjemne, zamysł wspaniały. Mała aktywność uczniów w domu spowodowana przesyceniem komputerem, ale na lekcji korzystali z platformy chętnie. Bardzo dobre rozwiązanie z resetowaniem hasła przez nauczyciela- szybko i łatwo. Korzystanie bardzo ułatwiał fakt rozłożenia tematów wg tematów lekcji. Super.'
  },
  {
  source: 'Zdzieszowice',
  opinion: 'Projekt godny polecenia.'
  },
  {
  source: 'Zgierz',
  opinion: 'Zeszyt jest skonstruowany bardzo dobrze, choć niektórzy uczniowie zniechęcali się podejmując kolejne próby rozwiązania zadania. Wskazywali, że nie wszystkie polecenia były dla nich zrozumiałe. Dla mnie super.'
  },
  {
  source: 'Zgorzelec',
  opinion: 'Bardzo fajne narzedzie do pracy. Uczniowie chetniej rozwiązywali zadania na platformie niż w ćwiczeniach i zeszytach papierowych. Nawet dzieci, które mają problem z zadaniami domowymi.'
  },
  {
  source: 'Złotów',
  opinion: 'Bardzo dobre zadania -świetnie utrwalające i rozwijające wiedzę matematyczną adekwatnie do potrzebi możliwości uczniów.'
  },
  {
  source: 'Złotów',
  opinion: 'Fantastyczny projekt, wspierający pracę nauczyciela i wspomagający proces nauczania uczniów. Elementem niesprzyjającym było zdalne nauczanie, ale bardzo bym chciała jak i moi uczniowie brać udział w kontynuacji. Czego brakowało? Nic, wszystko jest super'
  },
  {
  source: 'Złoty Stok',
  opinion: 'Zeszyt był bardzo pomocnym narzędziem w czasie nauki zdalnej, uczniowie także byli zadowoleni z takiej formy prac domowych. Zeszyt spełnił moje oczekiwania'
  },
  {
  source: 'Żabno',
  opinion: 'Cenne narzędzie. Umożliwia śledzenie postępów uczniów, ułatwia przeprowadzanie sprawdzianów, uatrakcyjnia konieczne w nauce matematyki powtarzanie.'
  },
  {
  source: 'Żabno',
  opinion: 'Spełnił moje oczekiwania. Nic nie brakowało. Nie uważam, żeby trzeba było coś dokładać czy ulepszać.'
  },
  {
  source: 'Żary',
  opinion: 'Bardzo fajny program który przydałby się gdyby nauka była stacjonarna'
  },
  {
  source: 'Żary',
  opinion: 'Projekt bardzo dobry. Dzieci, które uczestniczyły w nim łatwiej opanowywały nowe umiejętności, projekt pobudzał do myślenia.'
  },
  {
  source: 'Żary',
  opinion: 'Świetne narzędzie do pracy z uczniami na różnych poziomach umiejętności. Nie sądziłam, że będzie aż tak pomocne - szczególnie w okresie nauki zdalnej. Chętnie podejmę się kontynuacji w następnym roku szkolnym.'
  },
  {
  source: 'Żary',
  opinion: 'System online pozwala nauczycielowi sprawdzić poziom opanowania wiedzy i umiejętności uczniów. Świetnie sprawdza się funkcja sprawdziany oraz zadania domowe.'
  },
  {
  source: 'Żyrardów',
  opinion: 'Uczniowie z dużym zaangażowaniem rozwiazywali zadania i na pewno z chęcia przystapią do projektu w przyszłym roku szkolnym'
  },
  {
  source: 'Żywiec',
  opinion: 'Bardzo dobry pomysł na taki system, zwłaszcza podczas zdalnego nauczania. Uczniowie, którzy chcieli ćwiczyć poznane umiejętności matematyczne mogli to robić samodzielnie - dodatkowa nauka. Sprawdziany - dodatkowe narzędzie dla nauczyciela.'
  },
  {
  source: 'Żywiec',
  opinion: 'System zeszyt. online jest rewelacyjny. Podczas nauki zdalnej był doskonałą alternatywa dla zadań domowych pisanych w zeszycie a także sprawdzianów. Wykorzystywałam go także podczas lekcji. Można było śledzić aktywność uczniów, jak sobie radzą z danym tematem, ile błędów popełniają. Uczniowie bardzo chętnie rozwiązywali zadania, wręcz nie mogli się doczekać kiedy zadam im następne. Proponowanie uczniowi zadania łatwiejszego, gdy nie mógł rozwiązać bardzo ich motywowało i chętnie rozwiązywali zadane zadania. Nie korzystali z pomocy rodziców jak to często bywa przy zadaniach zadawanych z podręcznika. Mieli dużą satysfakcję, gdy udawało im się rozwiązać wszystkie zadania, nawet popełniając po drodze błędy. Szkoda, że tylko uczniowie klas 4 brali udział w projekcie. W obecnych czasach zeszyt.online przydałby się nauczycielom w każdej klasie.'
  },
  {
  source: 'Żywiec',
  opinion: 'Bardzo duże wsparcie dla nauczyciela'
  }];

  export let opinie_warszawa =
  [{
    source: 'Szkoła Podstawowa nr 306 w Warszawie, Bemowo',
    opinion: 'Praca na plaformie zeszytonline uatrakcyjniała uczniom naukę matematyki. Dzieci chętnie rozwiązywały zadania. Korzystanie z platformy jest łatwe zarówno dla dzieci jak i nauczycieli. Forma opisu postępów uczniów jest przejrzysta. Stopniowanie trudności pozwala na pracę w tym systemie zarówno uczniom zdolnym jak i mnie sprawnym matematycznie.'
    },
    {
    source: 'Szkoła Podstawowa nr 357 w Warszawie, Bemowo',
    opinion: 'System bardzo teraz wspomaga pracę z mojej klasy. Dzięki platformie dzieci utrwalają materiał i są w tej lepszej sytuacji. Rodzice i dzieci proszą o nowe zadania. Moja klasa jest teraz najlepsza z matematyki spośród wszystkich klas które uczę. Widać to po wynikach diagnozy moich uczniów oraz najlepiej radzą sobie ze sprawdzianami. Ci którzy na początku mieli opory, przełamali je. Dzieci są nastawione pozytywnie do zeszyt.online. Są pojedyncze przypadki które się poprawiły a pozostali jeszcze bardziej rozwinęli swoje umiejętności. Ja, moi uczniowie i rodzice jesteśmy bardzo zadowoleni z platformy.'
    },
    {
    source: 'Szkoła Podstawowa nr 368 w Warszawie,  Białołęka',
    opinion: 'Platforma zeszyt.online jest bardzo dobrym narzędziem wspomagającym pracę nauczyciela. W większości uczniowie bardzo chętnie logują się na platformę i rozwiązują na niej zadania. Cieszą ich bardzo przyznawane im tam kolejne stopnie awansu. Chwalą się nimi w rozmowach z innymi uczniami z klasy. Zaletą systemu jest to, że nauczyciel ma możliwość wygenerowania zestawu zadań z tematu aktualnie omawianego lub z tematu, który był omawiany wcześniej. Każdy nauczyciel to wie, że częste powtórki pozwalają uczniom dobrze utrwalić poznane wcześniej wiadomości. Jest to też duże ułatwienie dla nauczyciela, który chcąc zadać uczniom zadania utrwalające z innego działu, nie musi sam tworzyć kart pracy dla uczniów, a później ich sprawdzać. Uczeń natomiast zaraz po zrobieniu zadania, wie, czy zrobił je poprawnie. Jeśli mu się to nie udało, to jest on naprowadzany przez system na właściwy tok rozumowania, poprzez zadania pomocnicze. Dzięki temu, że aplikacja zeszyt.online działa również na telefonach z dostępem do internetu, uczniowie mają możliwość zrobienia zadań, np. w czasie podróży. Dużą zaletą pracy na platformie jest również to, iż uczniowie mają nieograniczony czas na wykonanie poszczególnych zadań i zadany moduł przez nauczyciela mogą podzielić sobie na etapy. Zadania znajdujące się na platformie zeszyt.online uczą dzieci czytania ze zrozumieniem tekstów matematycznych oraz wyciągania poprawnych wniosków. Z obserwacji uczniów widzę, że te dzieci, które systematycznie rozwiązują zadania zadawane przeze mnie na platformie zeszyt.online mają lepiej utrwalone umiejętności matematyczne zdobyte wcześniej na zajęciach matematyki. Najbardziej aktywną klasą, która pracuje na platformie zeszyt.online jest klasa 4c. Zadania zadawane są przeze mnie systematycznie raz na tydzień i duże grono uczniów z tej klasy czeka na nowy moduł i zależy im na tym, aby go rozwiązać jako pierwszy. Stopień trudności zadań jest zróżnicowany, co powoduje, że zadania są atrakcyjne zarówno dla uczniów słabszych, jak i tych zdolnych. Niektórzy rodzice mówili mi, że dzieci bardzo lubią rozwiązywać zadania na platformie.'
    },
    {
    source: 'Szkoła Podstawowa nr 212 w Warszawie,  Mokotów',
    opinion: 'Jestem bardzo zadowolona z platformy zeszyt.online. Współpracuję już z Państwem drugi rok i zadania wstawiane na platformie sprawiają dzieciom (które pracują na bieżąco od zeszłego roku) dużą frajdę. Słyszałam np. jak dzieci rozmawiają między sobą o stopniach, które już zdobyły. Zaproponowałam, aby teraz, kiedy odbywa się nauczanie zdalne dzieci nadal mogły korzystać z platformy zeszyt.online.'
    },
    {
    source: 'Szkoła Podstawowa nr 307 w Warszawie,  Mokotów',
    opinion: 'System jest prosty i przystępny w obsłudze. Ułatwia pracę, szczególnie teraz, gdy zajęcia są zawieszone. Uczniowie są zadowoleni i chętnie korzystają z platformy. Zwiększa atrakcyjność nauki. Po wprowadzeniu zeszyt.online, są uczniowie, którzy teraz chętniej uczestniczą w zajęciach matematyki, są aktywni, zgłaszają się do tablicy. U niektórych uczniów wzbudziła aktywność, bo dotychczas nie zgłaszali się. Uczniowie lubią korzystać z platformy i wolą takie formy pracy domowej niż z podręcznika. Rodzice twierdzą, że platforma budzi entuzjazm wśród ich dzieci i wykonują te zadania z chęcią.'
    },
    {
    source: 'Szkoła Podstawowa nr 61 w Warszawie,  Ochota',
    opinion: 'Praca z zeszytem online bardzo mi pomogła w zajęciach z uczniami na odległość. Jest to doskonałe narzędzie w tak trudnych dla nas czasach. W nauce w zwykłym trybie szkolnym jest zaś doskonałym uzupełnieniem. Szkoda, że nie mam możliwości pracy z klasą 6 lub 7. Gdyby coś takiego się pojawiło, to jestem pierwszą zainteresowaną. Uczniowie bardziej korzystają z podpowiedzi. Uczniowie, którzy systematycznie się logują, często swój dzień zaczynają od sprawdzenia zadań. Jeśli jest jakakolwiek możliwość dodania mojej 6 klasy, byłabym bardzo wdzięczna. Na pewno uczniowie bardzo by na tym skorzystali. Cieszę się bardzo, że zarówno moi uczniowie, jak i ja mogę korzystać z zasobów i pomocy Państwa Zespołu. Trzymam kciuki, abyście uzyskali wszelkie wsparcie programu, gdyż uważam, że Państwa zaangażowanie i doświadczenie z całą pewnością na to zasługuje.'
    },
    {
    source: 'Szkoła Podstawowa nr 73 w Warszawie,  Praga-Północ',
    opinion: 'Dziękujemy za możliwość poćwiczenia i wypróbowania nowych, atrakcyjnych narzędzi do matematyki. Zeszyty online wszystkim się podobały. Uczniowie słabsi dostali zadania dostosowane do ich możliwości, chętnie ćwiczyli. Uczniowie bardzo zdolni otrzymali dodatkowe wyzwanie, zadania podane w innej formie niż zwykle. Rywalizowali między sobą, kto zrobi więcej zadań, rozwiązywali na czas. Czekaliśmy na kontynuację w klasie V .…'
    },
    {
    source: 'Szkoła Podstawowa nr 189 w Warszawie,  Rembertów',
    opinion: 'Tylko praca z zeszytem on line była pracą pozwalającą uczyć się dzieciom w warunkach domowych. Inne platformy nie zapewniają nabywania przez uczniów wiedzy i umiejętności, żadne wykłady /lekcje on line, na poziomie podstawówki nie spełniają tej funkcji. Szczególnie było to widoczne w okresie tzw. pracy zdalnej. Dzieci chętnie robiły zdania i przekonali się bardzo rodzice do tego trybu ćwiczeń - mieli okazję bliżej przyjrzeć się pracy dziecka. Uczniowie polubili ćwiczenia on line., zarówno uczniowie zainteresowani matematyką jak i mający specyficzne trudności w uczeniu się.'
    },
    {
    source: 'Zespół Szkół Podstawowych nr 9 w Warszawie,  Wawer',
    opinion: 'Zeszyt.online jest narzędziem bardzo efektywnym. Pracują z nim chętnie uczniowie o różnych możliwościach. Dzieci uczą się również wytrwałości. Rozwiązują zadania nawet jeśli popełniają błędy, ponieważ wtedy kolejne zadania są łatwiejsze i pozwalają jednak uporać się z zadaną pracą domową. Wielu uczniów nie lubi pisać, zatem tutaj zaspokojona jest taka potrzeba. Ponadto system pozwala zadać pracę dłuższą i krótszą w zależności od wyboru nauczyciela. Raporty po zakończonym zadaniu pozwalają szybko sprawdzić, którzy uczniowie rozwiązali zadania, którzy je rozpoczęli oraz którzy nie rozpoczęli. Nauczyciel może również bardzo dokładnie przeanalizować sposób pracy poszczególnych uczniów korzystając z raportów szczegółowych. Tzn. sprawdzić jakie błędy popełnił uczeń, jakie zadania rozwiązał poprawnie, ile zadań pomocniczych rozwiązał, ile czasu zajęło mu rozwiązywanie poszczególnych zadań. Uczniowie pracują chętnie z zeszytem.online. Rodzice przekazują, że dzieci chcą pracować samodzielnie, nie pozwalają sobie pomagać. Pracuję z tym narzędziem od bardzo niedawna, ale uważam je za bardzo sprzyjające indywidualizacji nauczania, szczególnie zadań domowych.'
    },
    {
    source: 'Szkoła Podstawowa nr 86 w Warszawie,  Wawer',
    opinion: 'W klasach 4 dzieciaki upominają się o zadania z systemu i bardzo je lubią. Są uczniowie, którzy zaczęli się zgłaszać więcej do tablicy. Wielki pozytyw.'
    },
    {
    source: 'Szkoła Podstawowa nr 109 w Warszawie,  Wawer',
    opinion: 'Z zeszyt.online pracuję dopiero drugi tydzień, dlatego pewnie nie wszystko jeszcze w nim poznałam. System wg mnie jest prosty w obsłudze, ułatwił mi pracę - szczególnie teraz kiedy pracujemy zdalnie. Moi uczniowie lubią taką formę pracy, bo zwiększa to atrakcyjność lekcji, każdy pracuje na miarę swoich możliwości i przede wszystkim sam.'
    },
    {
    source: 'Szkoła Podstawowa nr 109 w Warszawie,  Wawer',
    opinion: 'System jest prosty w obsłudze, urozmaica i ułatwia pracę, a z problemem zawsze można liczyć na Państwa pomoc. Zadania w zeszycie.online rozwiązują głównie uczniowie, którzy lubią matematykę, są aktywni w klasie i w zeszycie oraz osiągają dobre wyniki w nauce przedmiotu. Uczniowie słabsi zaczynają małymi krokami próbować swoich sił. Mam nadzieję, że to kwestia czasu, by zwiększyło się grono zainteresowanych taką formą pracy.'
    },
    {
    source: 'Szkoła Podstawowa nr 109 w Warszawie,  Wawer',
    opinion: 'Pracuję z zeszytem od listopada. Super narzędzie. Ja moje dzieci z klas 4 i 6 są bardzo zadowolone.'
    },
    {
    source: 'Szkoła Podstawowa nr 138 w Warszawie,  Wawer',
    opinion: 'Uczniom bardzo podobają się zadania w online. Bardzo dużo się uczą. Zadania pomocnicze zachęcają ich do dalszej pracy i do matematyki. Dla nauczyciela praca z zeszytem online jest bardzo wygodna i pomocna. Nauczyciel bowiem widzi pracę każdego ucznia oraz jego ocenę w formie buźki i punktacji. Zeszyt online jest rewelacyjny.'
    },
    {
    source: 'Szkoła Podstawowa nr 216 w Warszawie,  Wawer',
    opinion: 'U mnie zeszyt.online stał się jednym z podstawowych narzędzi pracy on-line w tym czasie . Źródło jest dla dzieci znane i przejrzyste. Rodzice nie musieli panikować, że znowu coś nowego nauczyciel wymyślił. Mogłam zadawać nawet trochę więcej, bo było dużo czasu. Zdecydowana większość uczniów klas 5 czeka na nową pracę i właściwie rozwiązuje ją natychmiast po pojawieniu się. Pytają czy mogą pojawić się zadania na poczekanie, gdy zrobiło się pracę przed terminem. Uczniowie sami zauważają, że są zadania naprowadzające i samemu można dojść do poprawnego wyniku. Uważają to za duży plus. Szczególnie, że nie trzeba nikogo angażować do wytłumaczenia zadania. Zdaniem uczniów warto rozwijać tą aplikację. Niektórzy rodzice pytali nawet czy będzie dostępna w klasie 7'
    },
    {
    source: 'Szkoła Podstawowa nr 169 w Warszawie,  Wilanów',
    opinion: 'Uczniowie chcą pracować. Pytają czy w czasie tego koronawirusa też będzie zeszyt online.'
    },
    {
    source: 'Szkoła Podstawowa nr 261 w Warszawie,  Wilanów',
    opinion: 'Program zeszyt.online testowałam z jedną z klas czwartych. Większość uczniów w klasie chętnie korzystała z programu i wykonywała przydzielane im zadania. Dużym plusem było to, że program, wiedząc, że dziecko nie daje sobie rady z jakimś zadaniem, podsyłał do zrobienia łatwiejsze, identyfikował dlaczego dziecko ma problem i pomagał go rozwiązać od podstaw. Ja jako nauczyciel widziałam ile osób robi zadania, w jakim czasie i z jakim efektem. Program motywował uczniów do pracy, przez zdobywanie punktów i nagród. Przy pełnym korzystaniu z programu nauczyciel może wybierać zadania z dużej ich bazy. To bardzo ułatwia pracę zdalną z uczniem, pozwala też w szybszy sposób sprawdzać zadania i podsyłać kolejne w taki sposób, żeby nauka dawała efekty. '
    },
    {
    source: 'Szkoła Podstawowa nr 25 w Warszawie,  Wola',
    opinion: 'Dla mnie system jest genialny. Jeśli zostanie poszerzony i usunięte zostaną usterki, to będzie super. Najbardziej system pomaga uczniom słabym, z dysfunkcjami, takie mam informacje zwrotne od rodziców. Zainteresowanie jest i to duże. Proszę działać. Czekamy na więcej.'
    },
    {
    source: 'Szkoła Podstawowa nr 63 w Warszawie,  Wola',
    opinion: 'Obecnie z platformy zeszyt.online w szkole podstawowej nr 63 im. Zawiszy Czarnego w Warszawie korzysta 7 klas (czwarta, 4 piąte i 2 szóste). Klasy 4 i 5 używały platformy już od pierwszego semestru roku szkolnego 2019/2020. Klasy 6 zostały sprawnie dodane kilka dni po zamknięciu szkół z powodu pandemii (w marcu 2020). Uczniowie są zadowoleni, że mogą korzystać z platformy. Część uczniów, która niechętnie pracowała na zajęciach w szkole, chętnie wykonuje zadania online. Niektórzy nawet polubili dzięki tej platformie matematykę (choć wcześniej darzyli ją niechęcią). Dzieci nie zrażają się po błędnej odpowiedzi, ponieważ dostają zadania pomocnicze. Czują, że system analizuje ich odpowiedzi i pomaga im zrozumieć ich błąd, a następnie pomaga im samodzielnie dojść do prawidłowego rozwiązania. Ja jako nauczyciel jestem bardzo zadowolony z pracy z zeszyt.online. Poza możliwością uruchamiania zadań odpowiadających realizowanym poszczególnym działom matematyki, jest również dostęp do statystyk uczniów. Informacji jakie błędy zrobił, ile spędził czasu, jakie dodatkowe zadania wykonał. Pomaga to lepiej ocenić wkład ucznia w poznawanie matematyki. Poza poprawnymi odpowiedziami bardzo ważny jest również poświęcony zagadnieniu czas. Najlepsze w systemie jest to, że nie muszę samodzielnie dobierać uczniom zadań. Robi to automatycznie system, każdemu uczniowi indywidualnie wybierając zadania w zależności od jego umiejętności i aktualnych możliwości. Pozytywne opinie docierają do mnie także od rodziców. Cytat z jednej z otrzymanych wiadomości: „Syn jest bardzo zadowolony z tej formy nauki. Bardzo mu odpowiada i chętnie zasiada do robienia ćwiczeń. Bardzo dziękujemy i pozdrawiamy, czekamy na kolejne zadania.” Platforma zeszyt.online okazała się niezmiernie przydatna w procesie zdalnego nauczania matematyki w sytuacji pandemii koronawirusa. Pozwala ona zachować ciągłość w procesie edukacyjnym, natomiast w normalnych warunkach jest świetnym urozmaiceniem pracy ucznia.'
    },
    {
    source: 'Szkoła Podstawowa nr 132 w Warszawie,  Wola',
    opinion: 'Korzystanie z zeszyt.online to zauważalnie lepsze wyniki uczniów, którzy rozwiązują systematycznie zadania. To także połączenie przyjemnego z pożytecznym, dzięki zastosowaniu w platformie elementów gry (uczniowie zdobywają punkty/odznaczenia). A co najważniejsze uczniowie chętnie korzystają z tej opcji poszerzania swojej wiedzy. Zeszyt.online to ogromne wsparcie w pracy każdego nauczyciela, który chce zainteresować przedmiotem swoich wychowanków.'
    },
    {
    source: 'Szkoła Podstawowa nr 139 w Warszawie,  Wola',
    opinion: 'To jest najlepsze rozwiązanie na tą chwilę. Daje pełną informację na temat pracy ucznia. Jeśli to możliwe - proszę o rozszerzenie tego narzędzia na klasy siódme i ósme.'
    },
    {
    source: 'Szkoła Podstawowa nr 148 w Warszawie,  Wola',
    opinion: 'zeszyt.online pomaga mi w zróżnicowaniu pracy z uczniami. Platforma jest atrakcyjna i prosta w obsłudze. Super, że tematy są dopasowane tak jak w podręczniku. Łatwo sprawdza umiejętności dzieci. Świetnym sposobem jest to, że dopasowuje poziom do umiejętności dziecka. Uczniowie lubią pracę w zeszyt.online, zwłaszcza Ci najlepsi. Sami pytają czy zadam coś nowego. Zachęca ich do pracy zdobywanie kolejnych poziomów.'
    },
    {
    source: 'Szkoła Podstawowa nr 148 w Warszawie,  Wola',
    opinion: 'System jest bardzo pomocny w pracy zarówno dla mnie jak i dla uczniów. Dzieci chętnie odrabiają prace w zeszycie.online, są tacy którzy tylko tam ćwiczą w domu. Trudno wyegzekwować od nich pracę w zwykłych ćwiczeniach. Uczniowie mówią, że jest to dla nich atrakcyjna forma nauki i pomaga im w lepszym opanowaniu materiału. Widać to podczas kartkówek i sprawdzianów.'
    },
    {
    source: 'Szkoła Podstawowa nr 221 w Warszawie,  Wola',
    opinion: 'Większość uczniów mówi, że podoba im się taka forma pracy domowej i wolą odrabiać zadania na komputerze. Jest to dla nich atrakcyjniejsze i mam kilu uczniów, którzy prawie nigdy nie odrabiali prac domowych, a te robią. Mam kilku uczniów, którzy twierdzą, że mają dużą satysfakcję, jak uzyskują kolejny stopień wtajemniczenia.'
    },
    {
    source: 'Szkoła Podstawowa nr 221 w Warszawie,  Wola',
    opinion: 'Korzystam z platformy zeszyt.online drugi rok i jestem nim nieodmiennie zachwycona. Opinię  już wcześniej przekazywałam (nawet udzielałam wywiadu w radiu 😉). '+
            'Teraz nowymi użytkownikami stali się uczniowie klasy szóstej. Zebrałam od nich opinie nt. platformy i oto niektóre z nich:\n' +
            '• Maks – program super, lubię tu zaglądać i robić zadania\n'+
            '• Kamil – zrobiłem wszystko, co pani zadała, żeby tak było ze wszystkich przedmiotów (opinia ucznia mającego duże problemy z nauką matematyki)\n' +
            '• Maja – bardzo podoba mi się ta platforma, nauka matematyki jest atrakcyjniejsza\n' +
            '• Patrycja – nie miałam trudności, a jak miałam to dostawałam zadania pomocnicze\n' +
            'Nie było żadnych negatywnych opinii od uczniów.  Obserwując ich aktywność na platformie widzę, że większość uczniów wykonuje zadania od razu po otrzymaniu ode mnie informacji, że praca została udostępniona. Świadczy to o tym, że uczniowie są zaciekawieni nową formą nauki. Skuteczność jest na wysokim poziomie, nawet w przypadku słabych uczniów.'
    },
    {
    source: 'Szkoła Podstawowa nr 234 w Warszawie,  Wola',
    opinion: 'Zeszyt.online jest narzędziem z którego uczniowie bardzo chętnie korzystają. Jest łatwy w obsłudze, intuicyjny. Uczniowie rzadko zgłaszają problemy związane z trudnością zadań. Zgłaszają natomiast, że zadań w danym temacie jest za mało. Bardzo cieszę się, że planowana jest rozbudowa platformy.'
    },
    {
    source: 'Szkoła Podstawowa nr 234 w Warszawie,  Wola',
    opinion: 'Zeszyt jest super, specjalne podziękowania za 6 klasy. Obsługa prosta, bardzo ułatwia pracę. Szkoda, że geometrii w klasie piątej tak mało. Większość rodziców bardzo zadowolona - nie muszą pomagać dzieciom.'
    },
    {
    source: 'Szkoła Podstawowa nr 236 w Warszawie,  Wola',
    opinion: 'Moja 5 obecnie klasa pracuje z zeszytem online drugi rok. Świetne narzędzie dla mnie i dzieciaków szczególnie do powtórzenia materiału. Uczniowie pracują w większości chętnie. Są tacy, którzy czekają na zadania i chcą częściej je robić. Są też tacy, ale to pojedyncze przypadki, którzy niechętnie zaglądają do zadań. W zeszłym roku nagrodę za systematyczną pracę z zeszytem otrzymał uczeń, który głośno mówił ze nie lubi matematyki i miał z nią problemy. W tym roku czeka na każdą nową pracę z zeszytem. Duża tu również zasługa rodziców, którzy mobilizują do pracy. Chwalą program i są bardzo zadowoleni ze bierzemy udział w tym projekcie. Uważam że to świetna inicjatywa i bardzo pomocne narzędzie dla uczniów i nauczycieli.'
    }];

    export let opinie_okolice_warszawy =
    [{
      source: 'Szkoła Podstawowa w Wierzbnie',
      opinion: 'Jestem nauczycielem z wieloletnim stażem i od początku uczę matematyki w małej, wiejskiej szkole, przyszło mi się zmierzyć z nauczaniem, w którym należy wykorzystywać nowe technologie. Bardzo się cieszę, że mogę pracować z zeszytem.online. System jest prosty w obsłudze, przejrzysty, zadania zróżnicowane i pod względem trudności i różnej formy, grafiki - co uczniowie bardzo lubią. Nauczyciel otrzymuje o postępach każdego ucznia jak i klasy wiele informacji zwrotnych przydatnych w podnoszeniu jakości nauczania. Doskonałe zebranie wiadomości z każdego tematu ułatwia podsumowanie, a uczniowie są zadowoleni, że mogą wykonywać pracę domową na komputerze. Mam uczennicę, która mówi, że matematyka jest dla niej najtrudniejsza, ale zadane prace ma rozwiązane jako pierwsza i choć liczbowo najwięcej w całej klasie ich wykonuje - wyniki ma różne - to potrafi rano przed lekcjami już się zalogować i sprawdzić czy jest coś nowego. Teraz prawie wszyscy uczniowie chcą przychodzić na zajęcia wyrównawcze i rozwiązywać swoje zadania - w grupie lepiej i chętniej im się pracuje, nie czują zniechęcenia dążąc do jak najlepszego wyniku i uzyskania poziomu generała czy majora. Na przerwach podchodzą do mnie i opowiadają, co zrobili i ile, pytają czy zadałam coś nowego. Bardzo fajnie, że system wyłapuje z czym uczeń ma trudności i zadania pomocnicze są ukierunkowane na konkretny cel, podaje skuteczność i średni czas pracy, co jest bardzo ważną informacja dla nauczyciela. Na pewno system ułatwia pracę nauczycielowi, uatrakcyjnia lekcje z tego trudnego przedmiotu i pomaga go polubić. Powtórzę jeszcze raz. Projekt jest świetny, uczniowie są bardzo zadowoleni, rodzice również, zadania rozwiązują chętnie i bardzo systematycznie (choć z dostępem do internetu i komputera jest różnie). Wielkie dzięki za wspaniały pomysł, ogrom wkładanej pracy całemu zespołowi i przygarnięcie takiej malutkiej, wiejskiej szkoły jak nasza. Chcielibyśmy w przyszłym roku też wziąć udział w projekcie.'
      },
      {
      source: 'Szkoła Podstawowa w Nadarzynie',
      opinion: 'Pracujemy z zeszytem drugi rok. Od samego początku większość dzieci pracowała systematycznie. Uczniowie byli zainteresowani wykonywanymi zdaniami, zaangażowani w pracę. Dodatkową motywacją były osiągane stopnie awansu. Z rozmów z rodzicami wynikało, że nie musieli oni szczególnie motywować dzieci. Z efektów pracy, które starałam się śledzić na bieżąco wynikało, że raczej była to praca samodzielna. Dzieci pozytywnie wypowiadały się na temat grafiki i filmików. Wyniki sprawdzianów końcowych uczniów tej klasy na tle pozostałych były wysokie. Są też uczniowie, którzy mają trudności z matematyką, ale bardzo lubią pracować z zeszytem i ich oceny wcale nie są złe. Dzieci żałowały, że było mało geometrii (w zeszłym roku geometria bardzo się podobała). Jest to bardzo dobre narzędzie do pracy on line. Jako nauczyciel bardzo żałuję , że mam to narzędzie tylko w jednej klasie. Nie mam problemów z obsługą. Trzymam kciuki, żeby rozbudowa systemu oraz rozpowszechnienie się udało.'
      },
      {
      source: 'Szkoła Podstawowa nr 3 w Giżycku',
      opinion: 'zeszyt.online jest dużą pomocą w nauczaniu matematyki. Każdy uczeń rozwiązując tam zadania pracuje w swoim tempie. Zadania są również dobierane do jego możliwości i umiejętności. Pracując z zeszyt.online już drugi rok uczniowie są wdrożeni do pracy online. Sprawdziło się to znakomicie w ostatnich dniach. Uczniowie byli już zapoznani i przyzwyczajeni do nauki z komputerem. I dalej systematycznie co tydzień rozwiązują zadania w zeszyt.online tak, jak to było przed zawieszeniem zajęć w szkołach. Matematyka to przedmiot, którego nie da się nauczyć na pamięć. Im więcej zadań ktoś rozwiąże, tym dane zagadnienie lepiej opanuje. Zeszyt.online sprawdza się tu znakomicie. Jeżeli uczeń samodzielnie rozwiązuje np. 20 przykładów z mnożenia pisemnego i wszystkie robi źle, bo nikt tego nie kontroluje, to utrwala mu się zła metoda rozwiązania. Natomiast jeśli źle rozwiąże zadanie w zeszyt.online to oprócz niezaliczenia odpowiedzi dostaje jeszcze przykłady ułatwiające mu zrozumienie skąd ma błąd. Rodzice są zadowoleni, że dzieci mogą samodzielnie dodatkowo ćwiczyć matematykę. (Akurat rodzice uczniów klas V uważają, że najważniejsza jest matematyka i angielski). Uczniowie nabierają pewności siebie, nie boją się matematyki. Jestem bardzo zadowolona, że mogę brać udział w tym projekcie.'
      },
      {
      source: 'Szkoła Podstawowa nr 1 Ożarowie Mazowieckim',
      opinion: 'Wasza praca jest rewelacyjna. Jest to tak dobra platforma, że z żalem dopiero teraz ją odkrywamy i mamy wilczy apetyt na więcej opcji w tej aplikacji. Dzieci polubiły tę platformę, są aktywne i zmotywowane do pracy. Obsługa jest przyjazna a ja mogę kontrolować pracę uczniów na bieżąco. Szkoda, że nie mamy dostępu do klas 7 i 8. Mamy nadzieję, że otrzymamy stały dostęp do tej fantastycznej aplikacji. Uczniowie są bardzo zadowoleni. Jeśli my jako nauczyciele możemy w czymś pomóc, to jesteśmy do dyspozycji.'
      },
      {
      source: 'Szkoła Podstawowa nr 2 w Chorzelach',
      opinion: 'Uważam, że system jest łatwy w obsłudze i dobrze się z nim pracuje. Uczniowie bardzo entuzjastycznie przyjęli możliwość korzystania z niego. Chętnie też robią przydzielone zadania. Po zdobyciu kolejnych awansów chętnie się nimi chwalą. System wykorzystujemy raczej do pracy samodzielnej w domu, a w szkole jedynie omawiamy zadania. Po wykonaniu wszystkich - uczniowie wskazują, co było dla nich najtrudniejsze, a z czym nie mieli trudności. Chętnie dzielą się swoimi sposobami na rozwiązanie poszczególnych zadań. Zauważyłam, że uczennica, która jest dosyć słaba, nigdy się nie poddaje. Zawsze cierpliwie walczy z zadaniami. Podchodzi do nich przez kilka dni, ale zawsze dociera do celu. Na lekcji również zwiększyła się jej aktywność. Teraz chętniej sama zgłasza się do tablicy. Porażki już jej nie zniechęcają do podejmowania kolejnych wyzwań. Z innymi uczniami jest podobnie. O ile na początku roku do tablicy zgłaszali się nieliczni, to teraz mam na lekcji las rąk. I wielkie niezadowolenie, jak kogoś nie zdążę poprosić do przykładu podczas lekcji. O tym, że uczniowie są chętni do pracy w systemie, że polubili tę formę może świadczyć jeszcze jeden fakt. Ostatniego dnia, w którym odbywały się lekcje, przyszli poprosić mnie, aby zadania pojawiały się częściej niż raz w tygodniu. Uczniowie, rodzice i ja sama jesteśmy zadowoleni, że mogliśmy przystąpić do programu. Daje on wiele satysfakcji i pomaga w nauce.'
      },
      {
      source: 'Szkoła Podstawowa nr 2 w Ząbkach',
      opinion: 'Praca z zeszytem.online była dla mnie pomocnym narzędziem, zarówno w pracy z uczniem słabszym, jak i uzdolnionym. Pobudzała ich ciekawość i zainteresowanie matematyką. Na lekcjach matematyki uczniowie chętnie omawiali ciekawe i fajne ich zdaniem zadania, zadawali pytania do ćwiczeń, które sprawiały im trudność i tłumaczyli mi jakie pomocnicze przykłady podsyłał im system, żeby udało się je rozwiązać. Zeszyt.online pomagał uczniom zrozumieć zagadnienia, z którymi mieli kłopot. Dzieci podchodziły z dużym zaangażowaniem do rozwiązywania zadań. Od rodziców otrzymywałam bardzo pozytywne opinie. Cieszyli się, że można było połączyć siedzenie przed komputerem z czymś pożytecznym. Uważam, że teraz, w czasie kwarantanny byłoby to nieocenione narzędzie do pracy zdalnej.'
      },
      {
      source: 'Zespół Szkolno-Przedszkolny w Starej Wsi, gm. Celestynów',
      opinion: 'Moi uczniowie korzystają z zeszytu online od listopada 2019r. i jest on dostępny tylko dla klas 4. Dzięki niemu moi uczniowie chętniej uczą się matematyki. Są tacy którzy upominają się o więcej. Żałuję ze nie możemy korzystać z zeszytu online dla klas 5 i 6. Rodzice bardzo docenili tę platformę szczególnie teraz kiedy mamy ograniczony dostęp do nauczania stacjonarnego. Dziękowali mi za to, że tak możemy pracować. Także my jesteśmy bardzo zadowoleni.'
      },
      {
      source: 'Szkoła Podstawowa w Pomiechówku',
      opinion: 'Moi uczniowie lubią pracować w zeszycie.online. Niestety nie wszystkie dzieci dysponują odpowiednim sprzętem, ale Ci którzy mają sprzęt chętnie korzystają z tej formy nauki. Rodzice są również zadowoleni z tej formy pracy. Uczniowie chwalą sobie zadania pomocnicze i zdobywanie odpowiednich tytułów, jest to dla nich motywujące. Teraz kiedy szkoły są zamknięte jest to super ułatwienie i bardzo za nie wszystkim administratorom dziękuję.'
      },
      {
      source: 'Szkoła Podstawowa w Kołbieli',
      opinion: 'Uważam, że ten program  w zaistniałej sytuacji świetnie się sprawdza. Uczniowie i ich rodzice mają prosty, sprawdzony sposób powtórki materiału, co szczególnie ważne jest w klasie 4, czy 5 jak dzieci są zdane na pomoc starszych.'
      },
      {
      source: 'Szkoła Podstawowa w Dzierzgowie',
      opinion: 'Pracuję na platformie dopiero od stycznia z uczniami klasy 4, ale już mogę stwierdzić, że uczniowie bardzo chętnie wykonują tam ćwiczenia. Przy większości prac domowych mam 100% wykonanie (a nie wszyscy uczniowie są bardzo dobrzy z matematyki). Poruszanie po platformie jest łatwe, a uczniowie nabyli umiejętności, które teraz, gdy szkoły muszą pracować zdalnie bardzo im się przydają.  Szkoda, że nie mogę dołączyć starszych klas.'
      },
      {
      source: 'Szkoła Podstawowa w Regiminie',
      opinion: 'Uczniowie klasy 4 Szkoły Podstawowej im. Teofila Lenartowicza w Regiminie bardzo chętnie pracują na platformie zeszyt.online. Dzięki systemowi zadań uczniowie mogą usystematyzować i rozwinąć swoją wiedzę. Praca na platformie jest bardzo przystępna i przejrzysta. Uczniowie chwalą się swoimi zdobytymi odznaczeniami, które dostają podczas rozwiązywana zadań. Ja, jak i moi uczniowie jesteśmy bardzo zadowoleni z nawiązanej współpracy. '
      },
      {
      source: 'Szkoła Podstawowa w Świerczach',
      opinion: 'System jest prosty w obsłudze, ułatwia pracę, dzieci bez problemu się logują. Rodzice i uczniowie są zadowoleni. Słyszałam nawet zdania, że po raz pierwszy dziecko tak chętnie odrabia lekcje z matematyki. Praca z zeszytami ułatwia mi pracę. Będę z nich korzystała (oczywiście jeśli będzie taka możliwość) i w późniejszym czasie.'
      },
      {
      source: 'Szkoła Podstawowa w Świerczach',
      opinion: 'System bardzo przyjazny dla odbiorcy. Uczniowie, którzy często korzystali z tego systemu byli zadowoleni. Dopytywali się kiedy będą zadane następne prace, częściej zgłaszali się do odpowiedzi, nie bali się przedstawiać swoich pomysłów nawet, jeśli coś się nie udawało. Chętniej przychodzili też do tablicy. Rozwiązywali także dodatkowe zadania np. do konkursów. Podsumowując, system oceniam pozytywnie. Warto polecać go uczniom.'
      },
      {
      source: 'Szkoła Podstawowa nr 1 Błonie',
      opinion: 'Na zeszycie online pracuje mi się dobrze. Dzieci chętnie rozwiązują te prace domowe. Rodzice nic nie mówią, czyli jest dobrze. Twierdzę, że system zwiększa atrakcyjność nauki. Pomaga. Niektórzy chętniej patrzą na matematykę i się jej uczą, zgłaszają się. Teraz, gdy mamy nauczanie zdalne bardzo mi się przydaję i żałuję, że nie mam do 5 i 6 klasy. '
      },
      {
      source: 'Szkoła Podstawowa w Brochowie',
      opinion: 'Bardzo podoba mi się to, że teraz mogę nie tylko powtarzać na platformie, ale też wprowadzać coś nowego. Ogólnie platforma wzbudza mój zachwyt i zazdrość koleżanek z pracy, które nie mają dostępu do tego systemu.'
      },
      {
      source: 'Szkoła Podstawowa w Wiskitkach',
      opinion: 'Uczniowie klas 4-tych dla których mam założone zeszyty są zadowoleni z pracy online. Zadania są ciekawe, uczniowie mimo pojawiających się drobnych niepowodzeń, nie poddają się i chętnie pracują. W obecnej sytuacji, nauczania zdalnego, zeszytyonline są bardzo pomocne w nauczaniu matematyki i bardzo chętnie korzystałabym z nich w klasach starszych. Bardzo fajne narzędzie, atrakcyjny interface, łatwości w poruszaniu się to jedne z wielu zalet tego narzędzia.'
      },
      {
      source: 'Szkoła Podstawowa w Goworowie',
      opinion: 'System spodobał się uczniom i rodzicom. Z zeszyt.online pracuję bardzo krótko, a już teraz widzę czworo dzieci, którym ten system zauważalnie pomógł. Dzieci go lubią i proszą o dodatkowe zadania. Zwiększa to atrakcyjność i zainteresowanie matematyką. W sytuacji nauczania na odległość ten program to bardzo duża pomoc dla uczniów i nauczycieli.'
      },
      {
      source: 'Szkoła Podstawowa w Goworowie',
      opinion: 'Pracuje się dobrze, program zeszyt.online jest prosty w obsłudze, ułatwia pracę. Dostałem informację zwrotną od uczniów, którzy też pozytywnie wyrażają się o zeszycie. Jeszcze raz dzięki za dostęp do programu.'
      },
      {
      source: 'Szkoła Podstawowa nr 21 w Płocku',
      opinion: 'W klasach czwartych korzystamy z programu już od stycznia. W obecnej sytuacji platforma jest ogromnym ułatwieniem w pracy zarówno dla nauczycieli, jak i rodziców. W naszej szkole przesyłamy materiały dla dzieci poprzez mobidziennik - rodzic codzienne musi więc przekazać dziecku informację od każdego nauczyciela - jest to dość czasochłonne, często wymaga dostępu do drukarki. Na platformę dzieci logują się samodzielne, wiedzą w jakich dniach pojawiają się kolejne zadania do wykonania. Średni czas pracy również wskazuje, że zadania zazwyczaj nie są dużym obciążeniem.'
      },
      {
      source: 'Szkoła Podstawowa nr 2 w Mińsku Mazowieckim',
      opinion: 'Dziękuję za wsparcie z Państwa strony w zdalnym nauczaniu matematyki.'
      },
      {
      source: 'Szkoła Podstawowa nr 2 w Mińsku Mazowieckim',
      opinion: 'Zeszyt online ułatwia mi pracę, jest łatwy w obsłudze. Zeszyt pozwala kontrolować pracę uczniów. Rodzicom i uczniom również się podoba, chętnie siadają przed komputerem i rozwiązują zadania. '
      },
      {
      source: 'Szkoła Podstawowa nr 2 w Mińsku Mazowieckim',
      opinion: 'Jestem bardzo zadowolona z projektu. Podoba mi się to, że mogę obserwować gdzie dzieci popełniają błędy, kiedy logują się do systemu. Bardzo pomocne dla nauczyciela jest podsumowanie efektów pracy ucznia (można wstawiać plusy za terminowe wykonanie pracy). Obecnie mam taką możliwość (co mnie bardzo cieszy) pracować ze wszystkimi klasami, w których uczę na zeszyt.online. Są to klasy czwarta i szóste. Wielu rodziców pisało do mnie, że bardzo podoba się system oraz ich dzieciom, motywuje do zdobywania kolejnych stopni. Z opinii dzieciaków wiem, że wolą pracować na zeszyt.online niż rozwiązywać zadania w zeszycie przedmiotowym.'
      },
      {
      source: 'Szkoła Podstawowa w Krzynowłodze Małej',
      opinion: 'W naszej szkole praca na platformie zeszyt.online trwa od stycznia 2020r. Zalogowanych jest na niej 12 uczniów, z których  11 pracuje systematycznie. Zarówno nam nauczycielom, jak i uczniom oraz rodzicom  praca na platformie w takiej postaci odpowiada. Uczniowie chętnie rozwiązują zadania, wręcz czekają na każdą zadaną pracę. Dla uczniów słabszych służy jako narzędzie na którym w spokoju i samodzielnie mogą poćwiczyć. Cenne jest to, że źle rozwiązane zadanie nie oznacza końca pracy, a mobilizuje do kolejnych ćwiczeń na nowych prostszych zadaniach. Uczniowie mniej aktywni na lekcji, są bardzo aktywni na platformie. Platforma uatrakcyjnia  naukę matematyki, a tym samym pomaga w jej zrozumieniu. Uczniowie nie zgłaszają większych problemów zarówno w kwestii obsługi technicznej systemu, jak i pod względem trudności zadań. Platforma ma tę zaletę, że jest dość prosta w obsłudze i przyjazna dla ucznia i nauczyciela. Świadczy o tym  duże  zainteresowanie uczniów z klas starszych, którzy chcieliby dołączyć do pracy na platformie. Mamy nadzieję na dalszą współpracę i na to, że dalej będzie rozbudowywana.'
      },
      {
      source: 'Szkoła Podstawowa w Krasińcu, gm. Płoniawy-Bramura',
      opinion: 'Program bardzo dobry. Łatwy w obsłudze. Zadania z oprawą graficzną ułatwiającą uczniom udzielanie odpowiedzi. Umożliwiający nauczycielowi śledzenie postępów uczniów. Zadania o różnym stopniu trudności dopasowane do indywidualnych potrzeb i możliwości danego ucznia. Umożliwiający dokonywanie korekt błędnych odpowiedzi. Budzący zainteresowanie wśród większości uczniów. Ułatwiający uczniom opanowanie wiedzy matematycznej. W czasie trwania epidemii koronawirusa idealne narzędzie do zdalnej nauki matematyki!!! Czekam na możliwość korzystania z tego programu w pozostałych klasach szkoły podstawowej. '
      },
      {
      source: 'Szkoła Podstawowa nr 4 w Pułtusku',
      opinion: 'Uważam, że zeszyt.online to bardzo pomocne narzędzie w nauce matematyki. W mojej klasie jest bardzo mało uczniów, którzy w domu korzystają z tej pomocy (brak internetu, brak sprzętu). Zadania na zeszyt.online rozwiązujemy w szkole na zajęciach dodatkowych i widzę, że sprawia to uczniom dużą frajdę i dużo uczy.'
      },
      {
      source: 'Szkoła Podstawowa w Małej Wsi',
      opinion: 'System zeszyt.opnline ułatwia pracę, jest prosty w obsłudze. Uczniowie i rodzice są bardzo zadowoleni, że mogą go używać. Nie zgłaszali uwag. System pomaga uczniom w utrwalaniu materiału. Zwiększa atrakcyjność nauki matematyki. Dzieci lubią pracę z zeszyt.online. Po pierwszym dniu pracę wykonało 9/11 uczniów. Uczniowie czekają na te zestawy zadań. Są uczniowie, którzy dzięki zeszyt.online w większym stopniu zainteresowali się matematyką i ją polubili. Sali się aktywniejsi i chętniej chodzą do tablicy. Liczę na rozbudowanie systemu aż do klasy 8.'
      },
      {
      source: 'Szkoła Podstawowa w Starym Bosewie, gm. Długosiodło',
      opinion: 'Jest to bardzo dobre narzędzie, łatwość kontaktu, kontroli postępów, zadawania. Dodatkowo daje możliwość realizacji podstawy programowej, zgodnie z rozkładami, dostęp do typowych zadań dostosowanych do poziomu i możliwości każdego ucznia. Dosyć ważne z mojego punktu jest możliwość napisania wiadomości, przekazania opinii do zakończonej pracy, jak również do zadanej.'
      },
      {
      source: 'Szkoła Podstawowa w Ostrówku, gm. Łochów',
      opinion: 'Moi uczniowie do projektu (kl. 4) przystąpili dopiero po feriach. Przed zaistniałą sytuacją pracowali dodatkowo w domu, według założeń jeden moduł na tydzień. Obecnie korzystamy codziennie. Znacznie mamy ułatwioną pracę gdyż jesteśmy teraz tylko nauczycielami zdalnymi. Uważam, że moi uczniowie dużo skorzystali z zeszytów online. Według mnie praca w tej formie jest idealnym rozwiązaniem w obecnej sytuacji.'
      },
      {
      source: 'Szkoła Podstawowa w Strzale, gm. Siedlce',
      opinion: 'To jest bardzo pomocne w nauce matematyki. Uczniowie mają możliwość ćwiczenia i utrwalania wiedzy, a my nauczyciele możemy to kontrolować. Szkoda, że nie jest to dostępne dla klasy 7 i 8.'
      },
      {
      source: 'Szkoła Podstawowa w Kruszu, gm. Klembów',
      opinion: 'Dziękuję i dziękujemy za zeszyt.online, ciekawy sposób zainteresowania matematyką. Jest prosty w obsłudze, ułatwia wszystkim pracę. Uczniowie klasy 4 (pracujemy od 2019) bardzo lubią pracę w zeszycie, dopytywali na przerwach czy następna zadana, bo zaglądali, by zrobić, mówili o radościach z pokonania trudności. Uczniowie są aktywni, lubią wyzwania, zadania wymagające kreatywnego myślenia. Rodzice pochwalają tę pracę, choć zgłaszają sprawę dostępności internetu, stąd problemy z rozwiązywaniem zadań na czas u kilku uczniów.'
      },
      {
      source: 'Szkoła Podstawowa w Gniewoszowie',
      opinion: 'Mimo tego, że jest to jeszcze dość krótki okres pracy moich uczniów w systemie, to już można zaobserwować, że taka forma nauki i rozwiązywania zadań z matematyki bardzo im się podoba. Z pewnością korzystanie z systemu zwiększa w oczach ucznia atrakcyjność przedmiotu. Mogą pochwalić się na forum klasy swoimi osiągnięciami, zdobytymi punktami, wymienić spostrzeżenia - porozmawiać o tym, co sprawiło im trudność, a co było łatwe, zapytać o kolejne zadanie domowe. Łatwiej też jest zachęcić uczniów do pracy, myślę, że większość z nich podchodzi do nauki matematyki z większym entuzjazmem.'
      },
      {
      source: 'Szkoła Podstawowa w Przybyszewie, gm. Promna',
      opinion: 'System jest dobry, prosty w obsłudze. U mnie w klasie nie wszyscy mają sprawne urządzenia, dlatego korzystali wcześniej ze szkolnych laptopów. W tym czasie uczniowie byli bardziej aktywni. Chętnie rozwiązują zadania. Widzę u nich małą poprawę, a pracuję z systemem dopiero od lutego.'
      },
      {
      source: 'Szkoła Podstawowa nr 4 w Sochaczewie',
      opinion: 'System wzbudza we mnie pozytywne emocje. Nauczycielowi ułatwia pracę. Na pewno system pomaga i zwiększa atrakcyjność uczenia się matematyki dzieciom, które lubią matematykę i są nią zainteresowane (tacy uczniowie dopytują na lekcjach o zadaną pracę, chcą dodatkowe zadania - np. w czasie ferii, chętnie rozmawiają o zadanych przykładach, są aktywniejsi na lekcjach). Rodzice tych dzieci są zadowoleni, że dziecko w ten sposób uczy się i rozwija swoje zainteresowania.'
      },
      {
      source: 'Szkoła Podstawowa w Nowej Wsi, gm. Sokołów Podlaski',
      opinion: 'Nie zdążyłam przeszkolić uczniów przed zamknięciem szkół. Ale udało mi się mobilnie to zrobić. Pierwszy tydzień pracowaliśmy głownie z zeszytem online. Uczniowie są zachwyceni na razie tak samo jak ja. Dla mnie wszystko działa bez zarzutu.'
      },
      {
      source: 'Szkoła Podstawowa w Wiśniewie',
      opinion: 'zeszyt.online jest doskonałą formą pomocy w nauczaniu matematyki, szczególnie w zaistniałej sytuacji. Jest prosty w obsłudze. Wśród moich uczniów i ich rodziców ma same pozytywne opinie. Uczniowie bardzo chętnie pracują w zeszyt.online. Przyznawanie stopni za zdobyte punkty bardzo motywuje Ich do wykonywania kolejnych zadań. Podoba nam się to, że występują zadania pomocnicze, które ułatwiają zrobienie niektórych przykładów. Program jest bardzo pomocny.'
      },
      {
      source: 'Szkoła Podstawowa w Bogatem, gm. Przasnysz',
      opinion: 'Jestem bardzo zadowolona, rodzice również z pracy w zeszycie.online. Większość uczniów pracowała systematycznie, mogłam wychwycić który uczeń ma problemy z zadaną partią materiału. Zeszyt świetnie się sprawdza w pracy zdalnej, którą obecnie prowadzimy. Reasumując – świetny pomysł i pomoc w nauce.'
      },
      {
      source: 'Szkoła Podstawowa w Iłży',
      opinion: 'W tym projekcje uczestniczą dwie moje klasy 4, jedna w całości w drugiej większość uczniów. Generalnie dzieciom się bardzo podoba, chętnie rozwiązują zadania i wyczekują na kolejne prace domowe, ale niestety są też uczniowie którzy nie zaglądają. Przyczyną tego jest to, że nie mają komputera w domu. W szkole były udostępnione dwa komputery. W obecnej sytuacji zadałam dwie prace domowe i zaobserwowałam, że większa liczba uczniów zrobiła zadane zadnia.'
      },
      {
      source: 'Szkoła Podstawowa w Różanie',
      opinion: 'Moja klasa 4, która korzysta z zeszyt.online jest bardzo zachwycona. Uczniowie chętnie pracują, choć nie zawsze wykonują prace w wyznaczonym terminie. Wielokrotnie uczniowie proszą sami o zadanie pracy. Widać efekty ich samodzielnej pracy. Rodzice są bardzo zadowoleni, widzą większe zainteresowanie matematyką u dzieci, podkreślają, że podpowiedzi są bardzo cenne, że udział w projekcie bardzo pomaga.'
      },
      {
      source: 'Szkoła Podstawowa w Kadzidle',
      opinion: 'Z programu korzystamy krótko, bo dopiero od dwóch tygodni i to w tak trudnym czasie obecnie, gdy jest tylko zdalne nauczanie. Jednak ja jestem bardzo zadowolona z programu, uczniowie również. Bardzo podoba im się forma zadań, to, że dostają zadania pomocnicze, żeby rozwiązać główny problem, że zdobywają kolejne stopnie awansu. Uczniowie tak bardzo zaochocili się do pracy w programie, że wysyłają mi wiadomości o udostępnienie kolejnego zestawu, co czynię dość często, zwłaszcza teraz, gdy przebywają całe dnie w domach. Jest to bardzo dobra forma nauki i chciałabym w przyszłym roku również to kontynuować.'
      },
      {
      source: 'Szkoła Podstawowa w Białymbłocie, gm. Brańszczyk',
      opinion: 'Ułatwia pracę, zwłaszcza teraz gdy nauczanie odbywa się na odległość. Zeszyt osobiście podoba mi się. Chętnie chciałabym korzystać z zeszytów do klasy 6.'
      },
      {
      source: 'Szkoła Podstawowa w Słubicach',
      opinion: 'System bardzo prosty w obsłudze, dzieci zadowolone, rodzice również. Pojawiają się pytania, czy zeszytonline będzie również w piątej klasie. Dzieciaki bardzo chętnie wykonują zadania, sprawia im to przyjemność. Wśród swojej małej grupy mam uczniów, którzy pogłębiają swoją wiedzę matematyczną, są aktywniejsi i dopytują o kolejną serię zadań. Uczniowie deklarują chęć przystąpienia do projektu się na następnym roku, (cała klasa chętna). Mam nadzieję, że będziemy pracować również w następnym roku. W związku z tak trudną zaistniałą sytuacją w naszym kraju, uważam ze zeszyt online wspomaga nauczanie zdalne i na bieżąco wspomaga i monitoruje pracę uczniów.'
      },
      {
      source: 'Szkoła Podstawowa w Leoncinie',
      opinion: 'Moja opinia na temat zeszyty.online jest ona jak najbardziej pozytywna. Jeśli chodzi o moich uczniów to również bardzo chętnie pracują na tym programie. Oczywiście przodują najzdolniejsi i im ciągle mało. Zaobserwowałam też u kilkorga słabszych uczniów, że ten sposób pracy w domu na „spokojnie” i wiedząc, że zostaną nagrodzeni pozytywną oceną za aktywność sprawia, że pracują więcej z matematyki. W obecnej sytuacji jest to dodatkowe sprawdzone źródło możliwości pracy dla uczniów i ćwiczenia wiedzy, za co w tych trudnych czasach dziękuję i cieszę się że mogę korzystać ze swoimi uczniami.'
      }];
